// Auto-generated by scripts/generate-preset-cache.js — do not edit by hand.
// Regenerate with: node scripts/generate-preset-cache.js
window.__PRESET_DEFAULT_CACHE__ = {
  "lab-grown-diamond": {
    "Round": {
      "generatedAt": 1785812887535,
      "total": 107,
      "products": [
        {
          "id": "gid://shopify/Product/8214715072630",
          "title": "The Ashley Set With A Round Lab Diamond",
          "handle": "the-ashley-setting-round-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-R-YG_0_3x_jpg_c1b27dfa-a35f-4d9d-bc0c-ca925d06c857.webp?v=1785216904",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915772100726",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-R-YG_0_3x_jpg_c1b27dfa-a35f-4d9d-bc0c-ca925d06c857.webp?v=1785216904",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214745186422",
          "title": "The Eleanor Set With A Round Lab Diamond",
          "handle": "the-eleanor-setting-round-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-R-YG_0_3x_jpg_6a41a251-c05f-4299-a9dd-ef891d04ba22.webp?v=1785217851",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915836653686",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-R-YG_0_3x_jpg_6a41a251-c05f-4299-a9dd-ef891d04ba22.webp?v=1785217851",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214783197302",
          "title": "The Pave Ashley Set With A Round Lab Diamond",
          "handle": "the-ashley-setting-round-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-R-YG_0_3x_jpg_d7dc83ab-5338-4925-b99a-996c4f603fff.webp?v=1785218918",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916037783670",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-R-YG_0_3x_jpg_d7dc83ab-5338-4925-b99a-996c4f603fff.webp?v=1785218918",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214823239798",
          "title": "The Pave Eleanor Set With A Round Lab Diamond",
          "handle": "the-eleanor-setting-round-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-R-YG_0_3x_jpg_33398ae7-1111-4b25-b94c-ee4035372784.webp?v=1785220092",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916210471030",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-R-YG_0_3x_jpg_33398ae7-1111-4b25-b94c-ee4035372784.webp?v=1785220092",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214743122038",
          "title": "The Lexie Set With A Round Lab Diamond",
          "handle": "the-lexie-setting-round-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-R-YG_0_381a313a-3736-4c4c-9e1f-7bcc8f0b52b0.webp?v=1785217793",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915827478646",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-R-YG_0_381a313a-3736-4c4c-9e1f-7bcc8f0b52b0.webp?v=1785217793",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214796009590",
          "title": "The Pave Lexie Set With A Round Lab Diamond",
          "handle": "the-lexie-setting-round-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-R-YG_0_3x_jpg_2f0189e2-7f39-48d4-afe0-06452cc4ae0b.webp?v=1785219283",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916096241782",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-R-YG_0_3x_jpg_2f0189e2-7f39-48d4-afe0-06452cc4ae0b.webp?v=1785219283",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214747250806",
          "title": "The Alison Set With A Round Lab Diamond",
          "handle": "the-alison-setting-round-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-R-YG_0_3x_jpg_e4d203dd-059d-40f2-af82-c6a849a2d865.webp?v=1785217910",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915845959798",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-R-YG_0_3x_jpg_e4d203dd-059d-40f2-af82-c6a849a2d865.webp?v=1785217910",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214825205878",
          "title": "The Pave Alison Set With A Round Lab Diamond",
          "handle": "the-alison-setting-round-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-R-YG_0_3x_jpg_3684c0f2-7d73-4119-8b0b-fc15428351e3.webp?v=1785220153",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916219678838",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-R-YG_0_3x_jpg_3684c0f2-7d73-4119-8b0b-fc15428351e3.webp?v=1785220153",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214753771638",
          "title": "The Twig Set With A Round Lab Diamond",
          "handle": "the-twig-setting-round-polished-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1461.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-R-YG_0_3x_jpg_1991ed0d-5f75-4a9e-be08-0c57abf59dcf.webp?v=1785218084",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915876925558",
            "availableForSale": true,
            "price": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-R-YG_0_3x_jpg_1991ed0d-5f75-4a9e-be08-0c57abf59dcf.webp?v=1785218084",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2114.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38976000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214866002038",
          "title": "The Pave Twig Set With A Round Lab Diamond",
          "handle": "the-twig-setting-round-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1461.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-R-YG_0_3x_jpg_cb424ea2-ab56-43b4-b49a-06ad1d0a1189.webp?v=1785221365",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916428181622",
            "availableForSale": true,
            "price": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-R-YG_0_3x_jpg_cb424ea2-ab56-43b4-b49a-06ad1d0a1189.webp?v=1785221365",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2114.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38976000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214771138678",
          "title": "The Textured Twig Set With A Round Lab Diamond",
          "handle": "the-twig-setting-round-textured-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1461.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-R-YG_0_3x_jpg_34a0cd27-e039-4150-9900-f69248fa6217.webp?v=1785218551",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915965431926",
            "availableForSale": true,
            "price": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-R-YG_0_3x_jpg_34a0cd27-e039-4150-9900-f69248fa6217.webp?v=1785218551",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2114.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38976000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214833332342",
          "title": "The Pave Kamellie Set With A Round Lab Diamond",
          "handle": "the-kamellie-setting-round-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1461.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-R-YG_0_3x_jpg_20acfc38-2dbc-47b5-b938-fa4b3de83d7e.webp?v=1785220397",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916258771062",
            "availableForSale": true,
            "price": {
              "amount": "1647.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-R-YG_0_3x_jpg_20acfc38-2dbc-47b5-b938-fa4b3de83d7e.webp?v=1785220397",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1647.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2383.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43938000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214831202422",
          "title": "The Halo Twig Set With A Round Lab Diamond",
          "handle": "the-twig-setting-round-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1461.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-R-YG_0_3x_jpg_84b031d1-09ef-4df4-a44c-3b6a36f6863a.webp?v=1785220337",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916249038966",
            "availableForSale": true,
            "price": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-R-YG_0_3x_jpg_84b031d1-09ef-4df4-a44c-3b6a36f6863a.webp?v=1785220337",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2114.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38976000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214870524022",
          "title": "The Three Stone Twig Set With A Round Lab Diamond",
          "handle": "the-twig-setting-round-three-stone-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1461.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-R-YG_0_a560168e-2010-43f2-97d3-f976d8d86f98.jpg?v=1785221425",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916446564470",
            "availableForSale": true,
            "price": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-R-YG_0_a560168e-2010-43f2-97d3-f976d8d86f98.jpg?v=1785221425",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2114.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38976000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214760063094",
          "title": "The Nelly Set With A Round Lab Diamond",
          "handle": "the-nelly-setting-round-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-R-YG_0_3x_jpg_04e3bef1-f5d2-4ace-9102-9a4a3bc60c3e.webp?v=1785218259",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915917787254",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-R-YG_0_3x_jpg_04e3bef1-f5d2-4ace-9102-9a4a3bc60c3e.webp?v=1785218259",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214853615734",
          "title": "The Pave Nelly Set With A Round Lab Diamond",
          "handle": "the-nelly-setting-round-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-R-YG_0_3x_jpg_3005305d-ff4d-44e9-bf1d-0178c90d4c68.webp?v=1785220997",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916364349558",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-R-YG_0_3x_jpg_3005305d-ff4d-44e9-bf1d-0178c90d4c68.webp?v=1785220997",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214855876726",
          "title": "The Low Profile Kamellie Set With A Round Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-round-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-R-YG_0_3x_jpg_1eb5ebb3-3913-45dc-bd0c-d3ce015eb5b8.webp?v=1785221058",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916375720054",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-R-YG_0_3x_jpg_1eb5ebb3-3913-45dc-bd0c-d3ce015eb5b8.webp?v=1785221058",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214766092406",
          "title": "The Low Profile Kamellie Set With A Round Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-round-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-R-YG_0_3x_jpg_3cab6c90-626c-43ce-a88c-98af45cc99a7.webp?v=1785218431",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915945738358",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-R-YG_0_3x_jpg_3cab6c90-626c-43ce-a88c-98af45cc99a7.webp?v=1785218431",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214762061942",
          "title": "The Razor Kamellie Set With A Round Lab Diamond",
          "handle": "the-razor-kamellie-setting-round-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-R-YG_0_3x_jpg_33e31be2-19b4-496e-a6cc-e3417e8d2dcc.webp?v=1785218319",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915928273014",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-R-YG_0_3x_jpg_33e31be2-19b4-496e-a6cc-e3417e8d2dcc.webp?v=1785218319",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214755999862",
          "title": "The Sarah Set With A Round Lab Diamond",
          "handle": "the-sarah-setting-round-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1506.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-R-YG_0_3x_jpg_2ca2c3b6-4b6d-436a-b629-f5e30bb7d37c.webp?v=1785218144",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915898454134",
            "availableForSale": true,
            "price": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-R-YG_0_3x_jpg_2ca2c3b6-4b6d-436a-b629-f5e30bb7d37c.webp?v=1785218144",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2179.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "40177000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214847651958",
          "title": "The Pave Sarah Set With A Round Lab Diamond",
          "handle": "the-sarah-setting-round-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1506.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-R-YG_0_900a78c8-a370-41f4-81a8-87291d293d01.jpg?v=1785220827",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916329975926",
            "availableForSale": true,
            "price": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-R-YG_0_900a78c8-a370-41f4-81a8-87291d293d01.jpg?v=1785220827",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2179.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "40177000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214758031478",
          "title": "The Penelope Set With A Round Lab Diamond",
          "handle": "the-penelope-setting-round-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1551.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-R-YG_0_3x_jpg_462c1748-430a-45dc-a963-d6e6b73187f1.webp?v=1785218201",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915907825782",
            "availableForSale": true,
            "price": {
              "amount": "1551.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-R-YG_0_3x_jpg_462c1748-430a-45dc-a963-d6e6b73187f1.webp?v=1785218201",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1551.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2245.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "41377000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Oval": {
      "generatedAt": 1785812887535,
      "total": 112,
      "products": [
        {
          "id": "gid://shopify/Product/8214718546038",
          "title": "The Ashley Set With A Oval Lab Diamond",
          "handle": "the-ashley-setting-oval-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-OV-YG_0_3x_jpg_05bb5dbb-74dc-45bc-9446-765940c5ec8c.webp?v=1785217055",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915779145846",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-OV-YG_0_3x_jpg_05bb5dbb-74dc-45bc-9446-765940c5ec8c.webp?v=1785217055",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214783688822",
          "title": "The Pave Ashley Set With A Oval Lab Diamond",
          "handle": "the-ashley-setting-oval-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-OV-YG_0_3x_jpg_113d27cc-1d48-4d4e-9876-5cb138a6533b.webp?v=1785218925",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916039061622",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-OV-YG_0_3x_jpg_113d27cc-1d48-4d4e-9876-5cb138a6533b.webp?v=1785218925",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214745251958",
          "title": "The Eleanor Set With A Oval Lab Diamond",
          "handle": "the-eleanor-setting-oval-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-OV-YG_0_3x_jpg_a86b9a5f-63fb-466d-a319-8a27aa815440.webp?v=1785217858",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915837505654",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-OV-YG_0_3x_jpg_a86b9a5f-63fb-466d-a319-8a27aa815440.webp?v=1785217858",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214823272566",
          "title": "The Pave Eleanor Set With A Oval Lab Diamond",
          "handle": "the-eleanor-setting-oval-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-OV-YG_0_3x_jpg_5d1ac6ad-ab11-4fe5-a568-689432cbd141.webp?v=1785220101",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916211290230",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-OV-YG_0_3x_jpg_5d1ac6ad-ab11-4fe5-a568-689432cbd141.webp?v=1785220101",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214743908470",
          "title": "The Lexie Set With A Oval Lab Diamond",
          "handle": "the-lexie-setting-oval-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-OV-YG_0_8b7e82a8-0e03-4088-953c-520c9dd71581.webp?v=1785217800",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915829051510",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-OV-YG_0_8b7e82a8-0e03-4088-953c-520c9dd71581.webp?v=1785217800",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214796271734",
          "title": "The Pave Lexie Set With A Oval Lab Diamond",
          "handle": "the-lexie-setting-oval-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-OV-YG_0_3x_jpg_0ea4dc8b-e58d-4a7d-bbad-84c2e738f93e.webp?v=1785219290",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916097290358",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-OV-YG_0_3x_jpg_0ea4dc8b-e58d-4a7d-bbad-84c2e738f93e.webp?v=1785219290",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214825238646",
          "title": "The Pave Alison Set With A Oval Lab Diamond",
          "handle": "the-alison-setting-oval-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-OV-YG_0_3x_jpg_33955dda-ea56-4d71-afee-5ad9dad5e9a9.webp?v=1785220161",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916220498038",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-OV-YG_0_3x_jpg_33955dda-ea56-4d71-afee-5ad9dad5e9a9.webp?v=1785220161",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214747316342",
          "title": "The Alison Set With A Oval Lab Diamond",
          "handle": "the-alison-setting-oval-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-OV-YG_0_3x_jpg_a8c977dc-e36e-4318-bc66-7d3520ebbbae.webp?v=1785217917",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915846811766",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-OV-YG_0_3x_jpg_a8c977dc-e36e-4318-bc66-7d3520ebbbae.webp?v=1785217917",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214753837174",
          "title": "The Twig Set With A Oval Lab Diamond",
          "handle": "the-twig-setting-oval-polished-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1416.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-OV-YG_0_3x_jpg_6689a6a3-0010-4c86-b01c-d16f794bdb5a.webp?v=1785218092",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915877777526",
            "availableForSale": true,
            "price": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-OV-YG_0_3x_jpg_6689a6a3-0010-4c86-b01c-d16f794bdb5a.webp?v=1785218092",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2049.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37776000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214771171446",
          "title": "The Textured Twig Set With A Oval Lab Diamond",
          "handle": "the-twig-setting-oval-textured-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1416.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-OV-YG_0_3x_jpg_7d48639a-ded2-42a5-9ff1-1d0c86d28058.webp?v=1785218559",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915966251126",
            "availableForSale": true,
            "price": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-OV-YG_0_3x_jpg_7d48639a-ded2-42a5-9ff1-1d0c86d28058.webp?v=1785218559",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2049.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37776000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214831300726",
          "title": "The Halo Twig Set With A Oval Lab Diamond",
          "handle": "the-twig-setting-oval-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1416.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-OV-YG_0_3x_jpg_e1cefc3d-cb5a-4b08-9c38-6a266413efb6.webp?v=1785220344",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916250054774",
            "availableForSale": true,
            "price": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-OV-YG_0_3x_jpg_e1cefc3d-cb5a-4b08-9c38-6a266413efb6.webp?v=1785220344",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2049.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37776000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214866329718",
          "title": "The Pave Twig Set With A Oval Lab Diamond",
          "handle": "the-twig-setting-oval-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1416.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-OV-YG_0_3x_jpg_8b43f85d-5a7a-4899-b882-d7e5bd219162.webp?v=1785221373",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916429426806",
            "availableForSale": true,
            "price": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-OV-YG_0_3x_jpg_8b43f85d-5a7a-4899-b882-d7e5bd219162.webp?v=1785221373",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2049.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37776000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214871179382",
          "title": "The Three Stone Twig Set With A Oval Lab Diamond",
          "handle": "the-twig-setting-oval-three-stone-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1416.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-OV-YG_0_c5a5a769-42f3-4df6-837a-7049be64784e.jpg?v=1785221433",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916448858230",
            "availableForSale": true,
            "price": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-OV-YG_0_c5a5a769-42f3-4df6-837a-7049be64784e.jpg?v=1785221433",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1416.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2049.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37776000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214833365110",
          "title": "The Pave Kamellie Set With A Oval Lab Diamond",
          "handle": "the-kamellie-setting-oval-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1416.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-OV-YG_0_3x_jpg_f9c4333d-39b5-4502-8b73-9d236014ebf1.webp?v=1785220405",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916259721334",
            "availableForSale": true,
            "price": {
              "amount": "1647.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-OV-YG_0_3x_jpg_f9c4333d-39b5-4502-8b73-9d236014ebf1.webp?v=1785220405",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1647.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2383.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43938000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214756032630",
          "title": "The Sarah Set With A Oval Lab Diamond",
          "handle": "the-sarah-setting-oval-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1461.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-OV-YG_0_3x_jpg_9ff938dc-29b9-40d6-97f4-db0d6a1ecce8.webp?v=1785218151",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915899273334",
            "availableForSale": true,
            "price": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-OV-YG_0_3x_jpg_9ff938dc-29b9-40d6-97f4-db0d6a1ecce8.webp?v=1785218151",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2114.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38976000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214847783030",
          "title": "The Pave Sarah Set With A Oval Lab Diamond",
          "handle": "the-sarah-setting-oval-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1461.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-OV-YG_0_5e2c15b3-feda-4242-854f-e7c8ffc1aa74.jpg?v=1785220835",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916330893430",
            "availableForSale": true,
            "price": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-OV-YG_0_5e2c15b3-feda-4242-854f-e7c8ffc1aa74.jpg?v=1785220835",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1461.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2114.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38976000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214760128630",
          "title": "The Nelly Set With A Oval Lab Diamond",
          "handle": "the-nelly-setting-oval-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-OV-YG_0_3x_jpg_b55713de-b7c3-4f81-b90b-2b34db599aaf.webp?v=1785218267",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915919065206",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-OV-YG_0_3x_jpg_b55713de-b7c3-4f81-b90b-2b34db599aaf.webp?v=1785218267",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214762094710",
          "title": "The Razor Kamellie Set With A Oval Lab Diamond",
          "handle": "the-razor-kamellie-setting-oval-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-OV-YG_0_3x_jpg_40a56fb1-faf4-45c7-b45c-bfd9a76a7be3.webp?v=1785218327",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915929092214",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-OV-YG_0_3x_jpg_40a56fb1-faf4-45c7-b45c-bfd9a76a7be3.webp?v=1785218327",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214854008950",
          "title": "The Pave Nelly Set With A Oval Lab Diamond",
          "handle": "the-nelly-setting-oval-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-OV-YG_0_3x_jpg_cab51b80-5110-4260-8954-0e9c784b9059.webp?v=1785221005",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916367200374",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-OV-YG_0_3x_jpg_cab51b80-5110-4260-8954-0e9c784b9059.webp?v=1785221005",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214766125174",
          "title": "The Low Profile Kamellie Set With A Oval Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-oval-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-OV-YG_0_3x_jpg_281ccfa4-c2a4-4783-a9eb-e53885f5fa53.webp?v=1785218439",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915946557558",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-OV-YG_0_3x_jpg_281ccfa4-c2a4-4783-a9eb-e53885f5fa53.webp?v=1785218439",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214856040566",
          "title": "The Low Profile Kamellie Set With A Oval Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-oval-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-OV-YG_0_3x_jpg_d5c01c49-acad-48fa-8d72-1311ad79f18b.webp?v=1785221066",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916376670326",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-OV-YG_0_3x_jpg_d5c01c49-acad-48fa-8d72-1311ad79f18b.webp?v=1785221066",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214758064246",
          "title": "The Penelope Set With A Oval Lab Diamond",
          "handle": "the-penelope-setting-oval-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1506.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-OV-YG_0_3x_jpg_0afa536c-a537-43cf-8795-c92f2ab1ccae.webp?v=1785218209",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915909496950",
            "availableForSale": true,
            "price": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-OV-YG_0_3x_jpg_0afa536c-a537-43cf-8795-c92f2ab1ccae.webp?v=1785218209",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2179.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "40177000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Pear": {
      "generatedAt": 1785812887535,
      "total": 109,
      "products": [
        {
          "id": "gid://shopify/Product/8214727753846",
          "title": "The Ashley Set With A Pear Lab Diamond",
          "handle": "the-ashley-setting-pear-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-PS-YG_0_3x_jpg_75b990ca-8092-4c88-b610-1fe8e7648813.webp?v=1785217252",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915803197558",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-PS-YG_0_3x_jpg_75b990ca-8092-4c88-b610-1fe8e7648813.webp?v=1785217252",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214746300534",
          "title": "The Eleanor Set With A Pear Lab Diamond",
          "handle": "the-eleanor-setting-pear-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-PS-YG_0_3x_jpg_ea0449bd-9afb-4dc7-a3dc-cfc765fa49c2.webp?v=1785217865",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915839471734",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-PS-YG_0_3x_jpg_ea0449bd-9afb-4dc7-a3dc-cfc765fa49c2.webp?v=1785217865",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214823338102",
          "title": "The Pave Eleanor Set With A Pear Lab Diamond",
          "handle": "the-eleanor-setting-pear-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-PS-YG_0_3x_jpg_05a5236d-2e83-4401-b0e0-657784d3d214.webp?v=1785220107",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916212174966",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-PS-YG_0_3x_jpg_05a5236d-2e83-4401-b0e0-657784d3d214.webp?v=1785220107",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214783787126",
          "title": "The Pave Ashley Set With A Pear Lab Diamond",
          "handle": "the-ashley-setting-pear-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-PS-YG_0_3x_jpg_d3880955-cd77-4495-9656-7bb17eeab898.webp?v=1785218931",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916039946358",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-PS-YG_0_3x_jpg_d3880955-cd77-4495-9656-7bb17eeab898.webp?v=1785218931",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214744465526",
          "title": "The Lexie Set With A Pear Lab Diamond",
          "handle": "the-lexie-setting-pear-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-PS-YG_0_a948b22d-c75a-4b19-a6d3-80efc13f4bb5.webp?v=1785217806",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915830394998",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-PS-YG_0_a948b22d-c75a-4b19-a6d3-80efc13f4bb5.webp?v=1785217806",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214796337270",
          "title": "The Pave Lexie Set With A Pear Lab Diamond",
          "handle": "the-lexie-setting-pear-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-PS-YG_0_3x_jpg_ac33c2c0-44d1-4178-93be-5a5fd571f876.webp?v=1785219297",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916098142326",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-PS-YG_0_3x_jpg_ac33c2c0-44d1-4178-93be-5a5fd571f876.webp?v=1785219297",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214747381878",
          "title": "The Alison Set With A Pear Lab Diamond",
          "handle": "the-alison-setting-pear-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-PS-YG_0_3x_jpg_22150899-2fcf-4c00-aa2e-679b02f69b81.webp?v=1785217923",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915847663734",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-PS-YG_0_3x_jpg_22150899-2fcf-4c00-aa2e-679b02f69b81.webp?v=1785217923",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214825271414",
          "title": "The Pave Alison Set With A Pear Lab Diamond",
          "handle": "the-alison-setting-pear-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-PS-YG_0_3x_jpg_cb55175e-da08-4def-a4e1-9c561c6226fa.webp?v=1785220167",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916221317238",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-PS-YG_0_3x_jpg_cb55175e-da08-4def-a4e1-9c561c6226fa.webp?v=1785220167",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214753902710",
          "title": "The Twig Set With A Pear Lab Diamond",
          "handle": "the-twig-setting-pear-polished-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-PS-YG_0_3x_jpg_a728634a-ddd0-4715-94a9-70bd734daba6.webp?v=1785218098",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915878662262",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-PS-YG_0_3x_jpg_a728634a-ddd0-4715-94a9-70bd734daba6.webp?v=1785218098",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214831333494",
          "title": "The Halo Twig Set With A Pear Lab Diamond",
          "handle": "the-twig-setting-pear-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-PS-YG_0_3x_jpg_71152afe-cf47-4554-9ff7-322a0c0d883c.webp?v=1785220351",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916250873974",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-PS-YG_0_3x_jpg_71152afe-cf47-4554-9ff7-322a0c0d883c.webp?v=1785220351",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214771302518",
          "title": "The Textured Twig Set With A Pear Lab Diamond",
          "handle": "the-twig-setting-pear-textured-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-PS-YG_0_3x_jpg_c42af2c4-60c9-4073-983f-8e56a774b39f.webp?v=1785218567",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915968839798",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-PS-YG_0_3x_jpg_c42af2c4-60c9-4073-983f-8e56a774b39f.webp?v=1785218567",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214833430646",
          "title": "The Pave Kamellie Set With A Pear Lab Diamond",
          "handle": "the-kamellie-setting-pear-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-PS-YG_0_3x_jpg_6d0c7cba-ed62-42c4-8f91-4ac581080593.webp?v=1785220412",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916261064822",
            "availableForSale": true,
            "price": {
              "amount": "1647.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-PS-YG_0_3x_jpg_6d0c7cba-ed62-42c4-8f91-4ac581080593.webp?v=1785220412",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1647.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2383.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43938000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214866821238",
          "title": "The Pave Twig Set With A Pear Lab Diamond",
          "handle": "the-twig-setting-pear-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-PS-YG_0_3x_jpg_fd7be133-3934-4c8d-94ed-1bba01bd0dde.webp?v=1785221379",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916431982710",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-PS-YG_0_3x_jpg_fd7be133-3934-4c8d-94ed-1bba01bd0dde.webp?v=1785221379",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214871474294",
          "title": "The Three Stone Twig Set With A Pear Lab Diamond",
          "handle": "the-twig-setting-pear-three-stone-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-PS-YG_0_d381c0cf-35d7-42c4-9f85-6a7ffae503b4.jpg?v=1785221439",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916450529398",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-PS-YG_0_d381c0cf-35d7-42c4-9f85-6a7ffae503b4.jpg?v=1785221439",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214756065398",
          "title": "The Sarah Set With A Pear Lab Diamond",
          "handle": "the-sarah-setting-pear-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1407.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-PS-YG_0_3x_jpg_8bea2247-2690-41cc-9622-6842038b8487.webp?v=1785218158",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915900092534",
            "availableForSale": true,
            "price": {
              "amount": "1407.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-PS-YG_0_3x_jpg_8bea2247-2690-41cc-9622-6842038b8487.webp?v=1785218158",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1407.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2036.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37536000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214847815798",
          "title": "The Pave Sarah Set With A Pear Lab Diamond",
          "handle": "the-sarah-setting-pear-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1407.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-PS-YG_0_2e2c759c-19a8-492e-b1a1-283cded1d770.jpg?v=1785220842",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916332040310",
            "availableForSale": true,
            "price": {
              "amount": "1407.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-PS-YG_0_2e2c759c-19a8-492e-b1a1-283cded1d770.jpg?v=1785220842",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1407.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2036.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37536000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214762160246",
          "title": "The Razor Kamellie Set With A Pear Lab Diamond",
          "handle": "the-razor-kamellie-setting-pear-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-PS-YG_0_3x_jpg_5fcea1c3-82f0-42a6-975f-bf24502d2ffd.webp?v=1785218334",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915929944182",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-PS-YG_0_3x_jpg_5fcea1c3-82f0-42a6-975f-bf24502d2ffd.webp?v=1785218334",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214854140022",
          "title": "The Pave Nelly Set With A Pear Lab Diamond",
          "handle": "the-nelly-setting-pear-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-PS-YG_0_3x_jpg_36eb2e0a-88a4-4150-8892-934a967d0997.webp?v=1785221011",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916368117878",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-PS-YG_0_3x_jpg_36eb2e0a-88a4-4150-8892-934a967d0997.webp?v=1785221011",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214760161398",
          "title": "The Nelly Set With A Pear Lab Diamond",
          "handle": "the-nelly-setting-pear-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-PS-YG_0_3x_jpg_003d145e-78b6-4eb0-b4a8-b06556711e73.webp?v=1785218273",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915919884406",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-PS-YG_0_3x_jpg_003d145e-78b6-4eb0-b4a8-b06556711e73.webp?v=1785218273",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214766190710",
          "title": "The Low Profile Kamellie Set With A Pear Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-pear-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-PS-YG_0_3x_jpg_caff3957-cf7b-4c26-ab0e-762e77bd367a.webp?v=1785218445",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915947376758",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-PS-YG_0_3x_jpg_caff3957-cf7b-4c26-ab0e-762e77bd367a.webp?v=1785218445",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214856073334",
          "title": "The Low Profile Kamellie Set With A Pear Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-pear-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-PS-YG_0_3x_jpg_68c5f657-0e98-4f2b-9b6a-cec30f0f0f5a.webp?v=1785221072",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916377489526",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-PS-YG_0_3x_jpg_68c5f657-0e98-4f2b-9b6a-cec30f0f0f5a.webp?v=1785221072",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214775758966",
          "title": "The Victoria Set With A Pear Lab Diamond",
          "handle": "the-victoria-setting-pear-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1533.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-PS-YG_0_3x_jpg.webp?v=1785218689",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916001149046",
            "availableForSale": true,
            "price": {
              "amount": "1533.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-PS-YG_0_3x_jpg.webp?v=1785218689",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1533.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2219.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "40897000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Princess": {
      "generatedAt": 1785812887535,
      "total": 103,
      "products": [
        {
          "id": "gid://shopify/Product/8214739452022",
          "title": "The Ashley Set With A Princess Lab Diamond",
          "handle": "the-ashley-setting-princess-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-PR-YG_0_3x_jpg_f78b2666-3a53-4d6f-9fea-b3980e574317.webp?v=1785217675",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915821449334",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-PR-YG_0_3x_jpg_f78b2666-3a53-4d6f-9fea-b3980e574317.webp?v=1785217675",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214784901238",
          "title": "The Pave Ashley Set With A Princess Lab Diamond",
          "handle": "the-ashley-setting-princess-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-PR-YG_0_3x_jpg_9ef117cb-14c4-430d-97ff-7cbd9b3bafd2.webp?v=1785218964",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916045025398",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-PR-YG_0_3x_jpg_9ef117cb-14c4-430d-97ff-7cbd9b3bafd2.webp?v=1785218964",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214825009270",
          "title": "The Pave Eleanor Set With A Princess Lab Diamond",
          "handle": "the-eleanor-setting-princess-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-PR-YG_0_3x_jpg_e6008ff1-1f78-48a7-8c27-f01043a3d413.webp?v=1785220139",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916217909366",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-PR-YG_0_3x_jpg_e6008ff1-1f78-48a7-8c27-f01043a3d413.webp?v=1785220139",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214747119734",
          "title": "The Eleanor Set With A Princess Lab Diamond",
          "handle": "the-eleanor-setting-princess-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-PR-YG_0_3x_jpg_9597b5aa-ee9d-4d9b-bdfa-e5353a02c684.webp?v=1785217896",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915844255862",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-PR-YG_0_3x_jpg_9597b5aa-ee9d-4d9b-bdfa-e5353a02c684.webp?v=1785217896",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214745055350",
          "title": "The Lexie Set With A Princess Lab Diamond",
          "handle": "the-lexie-setting-princess-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-PR-YG_0_84db0959-04b3-4dcd-864f-8fd15f9ea474.webp?v=1785217837",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915834949750",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-PR-YG_0_84db0959-04b3-4dcd-864f-8fd15f9ea474.webp?v=1785217837",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214797353078",
          "title": "The Pave Lexie Set With A Princess Lab Diamond",
          "handle": "the-lexie-setting-princess-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-PR-YG_0_3x_jpg_c2774482-c38a-4f03-a761-00433ef532d0.webp?v=1785219335",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916103319670",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-PR-YG_0_3x_jpg_c2774482-c38a-4f03-a761-00433ef532d0.webp?v=1785219335",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214749249654",
          "title": "The Alison Set With A Princess Lab Diamond",
          "handle": "the-alison-setting-princess-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-PR-YG_0_3x_jpg_55da3b58-4aaa-40aa-b342-48376bb15aa3.webp?v=1785217954",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915853627510",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-PR-YG_0_3x_jpg_55da3b58-4aaa-40aa-b342-48376bb15aa3.webp?v=1785217954",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214827073654",
          "title": "The Pave Alison Set With A Princess Lab Diamond",
          "handle": "the-alison-setting-princess-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-PR-YG_0_3x_jpg_15776b5e-cf74-49cd-8d3c-3284676e4aee.webp?v=1785220200",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916227412086",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-PR-YG_0_3x_jpg_15776b5e-cf74-49cd-8d3c-3284676e4aee.webp?v=1785220200",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214834905206",
          "title": "The Pave Kamellie Set With A Princess Lab Diamond",
          "handle": "the-kamellie-setting-princess-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-PR-YG_0_3x_jpg_e916c056-67bb-4c76-9956-2303161138ab.webp?v=1785220445",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916267847798",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-PR-YG_0_3x_jpg_e916c056-67bb-4c76-9956-2303161138ab.webp?v=1785220445",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214753673334",
          "title": "The Kamellie Set With A Princess Lab Diamond",
          "handle": "the-kamellie-setting-princess-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-PR-YG_0_3x_jpg_ff37a887-2424-467e-b29f-c3a7ab86267b.webp?v=1785218071",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915875221622",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-PR-YG_0_3x_jpg_ff37a887-2424-467e-b29f-c3a7ab86267b.webp?v=1785218071",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214833135734",
          "title": "The Halo Twig Set With A Princess Lab Diamond",
          "handle": "the-twig-setting-princess-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-PR-YG_0_3x_jpg_45a9686a-254b-437d-b6cb-d612908937a9.webp?v=1785220384",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916257001590",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-PR-YG_0_3x_jpg_45a9686a-254b-437d-b6cb-d612908937a9.webp?v=1785220384",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214872948854",
          "title": "The Three Stone Twig Set With A Princess Lab Diamond",
          "handle": "the-twig-setting-princess-three-stone-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-PR-YG_0_3e66096f-6d60-4143-8006-014015f2f8f8.jpg?v=1785221471",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916460032118",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-PR-YG_0_3e66096f-6d60-4143-8006-014015f2f8f8.jpg?v=1785221471",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214755672182",
          "title": "The Twig Set With A Princess Lab Diamond",
          "handle": "the-twig-setting-princess-polished-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-PR-YG_0_3x_jpg_e9b11ce5-5d02-4319-80be-0a25dcf2401e.webp?v=1785218129",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915894816886",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-PR-YG_0_3x_jpg_e9b11ce5-5d02-4319-80be-0a25dcf2401e.webp?v=1785218129",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214772580470",
          "title": "The Textured Twig Set With A Princess Lab Diamond",
          "handle": "the-twig-setting-princess-textured-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-PR-YG_0_3x_jpg_f7086883-ce4e-4df0-b700-718eda63f56f.webp?v=1785218600",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915979423862",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-PR-YG_0_3x_jpg_f7086883-ce4e-4df0-b700-718eda63f56f.webp?v=1785218600",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214868525174",
          "title": "The Pave Twig Set With A Princess Lab Diamond",
          "handle": "the-twig-setting-princess-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-PR-YG_0_3x_jpg_dfcc02d0-d6a1-48f2-ae2d-4e65d43b09a6.webp?v=1785221412",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916441944182",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-PR-YG_0_3x_jpg_dfcc02d0-d6a1-48f2-ae2d-4e65d43b09a6.webp?v=1785221412",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214761963638",
          "title": "The Nelly Set With A Princess Lab Diamond",
          "handle": "the-nelly-setting-princess-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-PR-YG_0_3x_jpg_7fdc1299-f298-46d5-bd13-81d0c0bf8de0.webp?v=1785218306",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915926438006",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-PR-YG_0_3x_jpg_7fdc1299-f298-46d5-bd13-81d0c0bf8de0.webp?v=1785218306",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214854500470",
          "title": "The Pave Nelly Set With A Princess Lab Diamond",
          "handle": "the-nelly-setting-princess-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-PR-YG_0_3x_jpg_64a31946-29e2-4cbb-a5b5-e815112f73e7.webp?v=1785221044",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916372770934",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-PR-YG_0_3x_jpg_64a31946-29e2-4cbb-a5b5-e815112f73e7.webp?v=1785221044",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214856269942",
          "title": "The Low Profile Kamellie Set With A Princess Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-princess-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-PR-YG_0_3x_jpg_b7e1e3b3-ed91-436c-99c6-a4743a5c5de9.webp?v=1785221104",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916381683830",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-PR-YG_0_3x_jpg_b7e1e3b3-ed91-436c-99c6-a4743a5c5de9.webp?v=1785221104",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214767042678",
          "title": "The Low Profile Kamellie Set With A Princess Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-princess-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-PR-YG_0_3x_jpg_e244bc82-4554-408e-a9f9-fcb873e4a17f.webp?v=1785218478",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915952291958",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-PR-YG_0_3x_jpg_e244bc82-4554-408e-a9f9-fcb873e4a17f.webp?v=1785218478",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214763962486",
          "title": "The Razor Kamellie Set With A Princess Lab Diamond",
          "handle": "the-razor-kamellie-setting-princess-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-PR-YG_0_3x_jpg_5b89e81f-db1c-4aa0-8188-3ebc0c2915c9.webp?v=1785218369",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915935907958",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-PR-YG_0_3x_jpg_5b89e81f-db1c-4aa0-8188-3ebc0c2915c9.webp?v=1785218369",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214757834870",
          "title": "The Sarah Set With A Princess Lab Diamond",
          "handle": "the-sarah-setting-princess-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1497.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-PR-YG_0_3x_jpg_2ac83fe2-7483-4154-aa1a-7ffea8d64c5e.webp?v=1785218188",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915905826934",
            "availableForSale": true,
            "price": {
              "amount": "1497.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-PR-YG_0_3x_jpg_2ac83fe2-7483-4154-aa1a-7ffea8d64c5e.webp?v=1785218188",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1497.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2166.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39937000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214849323126",
          "title": "The Pave Sarah Set With A Princess Lab Diamond",
          "handle": "the-sarah-setting-princess-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1497.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-PR-YG_0_b778618b-9464-4048-910b-325837108f60.jpg?v=1785220875",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916341837942",
            "availableForSale": true,
            "price": {
              "amount": "1497.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-PR-YG_0_b778618b-9464-4048-910b-325837108f60.jpg?v=1785220875",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1497.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2166.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39937000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Cushion": {
      "generatedAt": 1785812887535,
      "total": 109,
      "products": [
        {
          "id": "gid://shopify/Product/8214730276982",
          "title": "The Ashley Set With A Cushion Lab Diamond",
          "handle": "the-ashley-setting-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-CU-YG_0_3x_jpg_336f15d5-c9c6-4f43-9fbd-8510a0a1fe96.webp?v=1785217329",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915806736502",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-CU-YG_0_3x_jpg_336f15d5-c9c6-4f43-9fbd-8510a0a1fe96.webp?v=1785217329",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214746333302",
          "title": "The Eleanor Set With A Cushion Lab Diamond",
          "handle": "the-eleanor-setting-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-CU-YG_0_3x_jpg_247a79d8-73f7-42a2-81ea-0b7893001067.webp?v=1785217871",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915840290934",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-CU-YG_0_3x_jpg_247a79d8-73f7-42a2-81ea-0b7893001067.webp?v=1785217871",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214783819894",
          "title": "The Pave Ashley Set With A Cushion Lab Diamond",
          "handle": "the-ashley-setting-cushion-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-CU-YG_0_3x_jpg_0509b341-8d73-4bab-ad91-7ebae1963e55.webp?v=1785218938",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916040765558",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-CU-YG_0_3x_jpg_0509b341-8d73-4bab-ad91-7ebae1963e55.webp?v=1785218938",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214823370870",
          "title": "The Pave Eleanor Set With A Cushion Lab Diamond",
          "handle": "the-eleanor-setting-cushion-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-CU-YG_0_3x_jpg_cbaec1fd-6554-46d0-8ab8-4d39c19a5dcc.webp?v=1785220113",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916212994166",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-CU-YG_0_3x_jpg_cbaec1fd-6554-46d0-8ab8-4d39c19a5dcc.webp?v=1785220113",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214744891510",
          "title": "The Lexie Set With A Cushion Lab Diamond",
          "handle": "the-lexie-setting-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-CU-YG_0_36dc52f7-1cf5-46f2-a2cc-cc471832deaa.webp?v=1785217813",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915831640182",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-CU-YG_0_36dc52f7-1cf5-46f2-a2cc-cc471832deaa.webp?v=1785217813",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214796468342",
          "title": "The Pave Lexie Set With A Cushion Lab Diamond",
          "handle": "the-lexie-setting-cushion-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-CU-YG_0_3x_jpg_c58bde0c-1464-4f73-a7ed-ae29064b49e6.webp?v=1785219308",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916099289206",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-CU-YG_0_3x_jpg_c58bde0c-1464-4f73-a7ed-ae29064b49e6.webp?v=1785219308",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214748168310",
          "title": "The Alison Set With A Cushion Lab Diamond",
          "handle": "the-alison-setting-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-CU-YG_0_3x_jpg_397eeaa1-f512-4f7a-a42e-36a0633970da.webp?v=1785217930",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915849334902",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-CU-YG_0_3x_jpg_397eeaa1-f512-4f7a-a42e-36a0633970da.webp?v=1785217930",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214825336950",
          "title": "The Pave Alison Set With A Cushion Lab Diamond",
          "handle": "the-alison-setting-cushion-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-CU-YG_0_3x_jpg_38e0cc55-260b-4951-b04d-6d627013ff6b.webp?v=1785220175",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916222169206",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-CU-YG_0_3x_jpg_38e0cc55-260b-4951-b04d-6d627013ff6b.webp?v=1785220175",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214751805558",
          "title": "The Kamellie Set With A Cushion Lab Diamond",
          "handle": "the-kamellie-setting-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-CU-YG_0_3x_jpg_9c331bcf-12d0-44f0-81c7-f4285f12a46b.webp?v=1785218045",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915869519990",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-CU-YG_0_3x_jpg_9c331bcf-12d0-44f0-81c7-f4285f12a46b.webp?v=1785218045",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214754033782",
          "title": "The Twig Set With A Cushion Lab Diamond",
          "handle": "the-twig-setting-cushion-polished-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-CU-YG_0_3x_jpg_c9bad80c-137d-4682-acfd-df31eac2994b.webp?v=1785218105",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915879841910",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-CU-YG_0_3x_jpg_c9bad80c-137d-4682-acfd-df31eac2994b.webp?v=1785218105",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214833463414",
          "title": "The Pave Kamellie Set With A Cushion Lab Diamond",
          "handle": "the-kamellie-setting-cushion-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-CU-YG_0_3x_jpg_d2bd639c-c705-4c31-880e-fd3fcf7cf4e5.webp?v=1785220419",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916261884022",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-CU-YG_0_3x_jpg_d2bd639c-c705-4c31-880e-fd3fcf7cf4e5.webp?v=1785220419",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214867247222",
          "title": "The Pave Twig Set With A Cushion Lab Diamond",
          "handle": "the-twig-setting-cushion-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-CU-YG_0_3x_jpg_107522ea-7ac3-4dd1-a4b9-2ac78840428a.webp?v=1785221386",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916434112630",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-CU-YG_0_3x_jpg_107522ea-7ac3-4dd1-a4b9-2ac78840428a.webp?v=1785221386",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214831399030",
          "title": "The Halo Twig Set With A Cushion Lab Diamond",
          "handle": "the-twig-setting-cushion-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-CU-YG_0_3x_jpg_277d3fa5-99cf-48cf-8740-19f998436147.webp?v=1785220358",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916251725942",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-CU-YG_0_3x_jpg_277d3fa5-99cf-48cf-8740-19f998436147.webp?v=1785220358",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214771368054",
          "title": "The Textured Twig Set With A Cushion Lab Diamond",
          "handle": "the-twig-setting-cushion-textured-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-CU-YG_0_3x_jpg_b0a9b52f-2e47-490b-badc-a15008003b5e.webp?v=1785218573",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915969921142",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-CU-YG_0_3x_jpg_b0a9b52f-2e47-490b-badc-a15008003b5e.webp?v=1785218573",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214871801974",
          "title": "The Three Stone Twig Set With A Cushion Lab Diamond",
          "handle": "the-twig-setting-cushion-three-stone-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1362.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-CU-YG_0_01672aa0-7b4c-4005-83c5-a81b5f70ab9f.jpg?v=1785221446",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916452823158",
            "availableForSale": true,
            "price": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-CU-YG_0_01672aa0-7b4c-4005-83c5-a81b5f70ab9f.jpg?v=1785221446",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1362.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1971.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36335000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214847848566",
          "title": "The Pave Sarah Set With A Cushion Lab Diamond",
          "handle": "the-sarah-setting-cushion-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1407.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-CU-YG_0_bcee3244-81f2-484b-9eb5-26cc01b896ec.jpg?v=1785220849",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916332859510",
            "availableForSale": true,
            "price": {
              "amount": "1407.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-CU-YG_0_bcee3244-81f2-484b-9eb5-26cc01b896ec.jpg?v=1785220849",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1407.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2036.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37536000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214756098166",
          "title": "The Sarah Set With A Cushion Lab Diamond",
          "handle": "the-sarah-setting-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1407.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-CU-YG_0_3x_jpg_c16c5948-0566-4f83-887a-57488a9e7406.webp?v=1785218164",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915900911734",
            "availableForSale": true,
            "price": {
              "amount": "1407.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-CU-YG_0_3x_jpg_c16c5948-0566-4f83-887a-57488a9e7406.webp?v=1785218164",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1407.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2036.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37536000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214758162550",
          "title": "The Penelope Set With A Cushion Lab Diamond",
          "handle": "the-penelope-setting-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1452.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-CU-YG_0_3x_jpg_4a2e2d93-09fc-459d-838b-bd5fa1d883b0.webp?v=1785218221",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915911168118",
            "availableForSale": true,
            "price": {
              "amount": "1452.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-CU-YG_0_3x_jpg_4a2e2d93-09fc-459d-838b-bd5fa1d883b0.webp?v=1785218221",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1452.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2101.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38736000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214835527798",
          "title": "The Hidden Halo Penelope Set With A Cushion Lab Diamond",
          "handle": "the-penelope-setting-cushion-hidden-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1452.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/216Q-ER-CU-YG_0_3x_jpg_368550ca-be1d-41f1-88f9-564c2bdfb016.webp?v=1785220481",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916272402550",
            "availableForSale": true,
            "price": {
              "amount": "1452.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/216Q-ER-CU-YG_0_3x_jpg_368550ca-be1d-41f1-88f9-564c2bdfb016.webp?v=1785220481",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1452.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2101.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38736000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214760226934",
          "title": "The Nelly Set With A Cushion Lab Diamond",
          "handle": "the-nelly-setting-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-CU-YG_0_3x_jpg_f5e7c077-01b5-4df5-acb5-c8ecf0197cc8.webp?v=1785218279",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915921555574",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-CU-YG_0_3x_jpg_f5e7c077-01b5-4df5-acb5-c8ecf0197cc8.webp?v=1785218279",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214762193014",
          "title": "The Razor Kamellie Set With A Cushion Lab Diamond",
          "handle": "the-razor-kamellie-setting-cushion-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-CU-YG_0_3x_jpg_b4dea09b-0022-434e-aba0-45420added0f.webp?v=1785218341",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915930763382",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-CU-YG_0_3x_jpg_b4dea09b-0022-434e-aba0-45420added0f.webp?v=1785218341",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214854172790",
          "title": "The Pave Nelly Set With A Cushion Lab Diamond",
          "handle": "the-nelly-setting-cushion-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-CU-YG_0_3x_jpg_84d9dd72-2f0d-4b26-99bc-19d33efd6fec.webp?v=1785221017",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916368937078",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-CU-YG_0_3x_jpg_84d9dd72-2f0d-4b26-99bc-19d33efd6fec.webp?v=1785221017",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "E. Cushion": {
      "generatedAt": 1785812887535,
      "total": 90,
      "products": [
        {
          "id": "gid://shopify/Product/8214731980918",
          "title": "The Ashley Set With A Elongated Cushion Lab Diamond",
          "handle": "the-ashley-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1342.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-ECU-YG_0_3x_jpg_8787e8c2-afec-4732-a0dd-4ee8c05b1322.webp?v=1785217378",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915809357942",
            "availableForSale": true,
            "price": {
              "amount": "1342.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-ECU-YG_0_3x_jpg_8787e8c2-afec-4732-a0dd-4ee8c05b1322.webp?v=1785217378",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1342.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1943.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35815000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214744924278",
          "title": "The Lexie Set With A Elongated Cushion Lab Diamond",
          "handle": "the-lexie-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1392.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-ECU-YG_0_c4bcf785-e89b-41db-a46d-b6be9c8de54d.webp?v=1785217819",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915832459382",
            "availableForSale": true,
            "price": {
              "amount": "1392.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-ECU-YG_0_c4bcf785-e89b-41db-a46d-b6be9c8de54d.webp?v=1785217819",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1392.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2015.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37149000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214747021430",
          "title": "The Eleanor Set With A Elongated Cushion Lab Diamond",
          "handle": "the-eleanor-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1442.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-ECU-YG_0_3x_jpg_bad7c9d3-46ee-43fc-a637-26ab284ac825.webp?v=1785217878",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915841798262",
            "availableForSale": true,
            "price": {
              "amount": "1442.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-ECU-YG_0_3x_jpg_bad7c9d3-46ee-43fc-a637-26ab284ac825.webp?v=1785217878",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1442.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38483000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214748463222",
          "title": "The Alison Set With A Elongated Cushion Lab Diamond",
          "handle": "the-alison-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1442.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-ECU-YG_0_3x_jpg_e94a865c-83e7-465a-9704-db5685e93a00.webp?v=1785217936",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915850416246",
            "availableForSale": true,
            "price": {
              "amount": "1442.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-ECU-YG_0_3x_jpg_e94a865c-83e7-465a-9704-db5685e93a00.webp?v=1785217936",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1442.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38483000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214751117430",
          "title": "The Katelyn Set With A Elongated Cushion Lab Diamond",
          "handle": "the-katelyn-setting-elongated-cushion-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1492.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-ECU-YG_0_41b15c17-0f85-4557-ae80-0dcb9873d818.jpg?v=1785217993",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915860344950",
            "availableForSale": true,
            "price": {
              "amount": "1492.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-ECU-YG_0_41b15c17-0f85-4557-ae80-0dcb9873d818.jpg?v=1785217993",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1492.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2160.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39817000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214752624758",
          "title": "The Kamellie Set With A Elongated Cushion Lab Diamond",
          "handle": "the-kamellie-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1542.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-ECU-YG_0_3x_jpg_7fae1994-89a1-40af-93b7-2187d66c233c.webp?v=1785218052",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915871092854",
            "availableForSale": true,
            "price": {
              "amount": "1542.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-ECU-YG_0_3x_jpg_7fae1994-89a1-40af-93b7-2187d66c233c.webp?v=1785218052",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1542.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2232.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "41150000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214754689142",
          "title": "The Twig Set With A Elongated Cushion Lab Diamond",
          "handle": "the-twig-setting-elongated-cushion-polished-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1542.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-ECU-YG_0_3x_jpg_0dcbd236-289b-430d-884a-152e42a1c6b2.webp?v=1785218111",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915881283702",
            "availableForSale": true,
            "price": {
              "amount": "1542.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-ECU-YG_0_3x_jpg_0dcbd236-289b-430d-884a-152e42a1c6b2.webp?v=1785218111",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1542.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2232.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "41150000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214756524150",
          "title": "The Sarah Set With A Elongated Cushion Lab Diamond",
          "handle": "the-sarah-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1592.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-ECU-YG_0_3x_jpg_9f894d5f-79a1-4609-9d5f-31bd802e73ea.webp?v=1785218170",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915902124150",
            "availableForSale": true,
            "price": {
              "amount": "1592.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-ECU-YG_0_3x_jpg_9f894d5f-79a1-4609-9d5f-31bd802e73ea.webp?v=1785218170",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1592.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2305.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "42484000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214764388470",
          "title": "The Alex Set With A Elongated Cushion Lab Diamond",
          "handle": "the-alex-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1642.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-ECU-YG_0_3x_jpg_e86def54-dc15-47a6-9b1a-1b18600ccf4e.webp?v=1785218411",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915941183606",
            "availableForSale": true,
            "price": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-ECU-YG_0_3x_jpg_e86def54-dc15-47a6-9b1a-1b18600ccf4e.webp?v=1785218411",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2377.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43818000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214768550006",
          "title": "The Berta Set With A Elongated Cushion Lab Diamond",
          "handle": "the-berta-setting-elongated-cushion-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1642.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-ECU-YG_0_0e89233e-22f0-41b0-b06b-16ef5de8de51.jpg?v=1785218519",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915958845558",
            "availableForSale": true,
            "price": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-ECU-YG_0_0e89233e-22f0-41b0-b06b-16ef5de8de51.jpg?v=1785218519",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2377.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43818000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214762258550",
          "title": "The Razor Kamellie Set With A Elongated Cushion Lab Diamond",
          "handle": "the-razor-kamellie-setting-elongated-cushion-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1642.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-ECU-YG_0_3x_jpg_86786f39-a9be-450a-8344-c708d6c9a772.webp?v=1785218347",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915931811958",
            "availableForSale": true,
            "price": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-ECU-YG_0_3x_jpg_86786f39-a9be-450a-8344-c708d6c9a772.webp?v=1785218347",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2377.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43818000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214760259702",
          "title": "The Nelly Set With A Elongated Cushion Lab Diamond",
          "handle": "the-nelly-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1642.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-ECU-YG_0_3x_jpg_42389050-d006-4ee4-a917-a2f7fc5673dd.webp?v=1785218286",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915922374774",
            "availableForSale": true,
            "price": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-ECU-YG_0_3x_jpg_42389050-d006-4ee4-a917-a2f7fc5673dd.webp?v=1785218286",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2377.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43818000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214758195318",
          "title": "The Penelope Set With A Elongated Cushion Lab Diamond",
          "handle": "the-penelope-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1642.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-ECU-YG_0_3x_jpg_b9c92079-0bb8-4762-96ea-1c264140b917.webp?v=1785218227",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915911987318",
            "availableForSale": true,
            "price": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-ECU-YG_0_3x_jpg_b9c92079-0bb8-4762-96ea-1c264140b917.webp?v=1785218227",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2377.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43818000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214771466358",
          "title": "The Textured Twig Set With A Elongated Cushion Lab Diamond",
          "handle": "the-twig-setting-elongated-cushion-textured-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1642.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-ECU-YG_0_3x_jpg_6cea4207-7d12-4258-b968-90de6d272d9f.webp?v=1785218580",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915972378742",
            "availableForSale": true,
            "price": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-ECU-YG_0_3x_jpg_6cea4207-7d12-4258-b968-90de6d272d9f.webp?v=1785218580",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2377.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43818000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214766321782",
          "title": "The Low Profile Kamellie Set With A Elongated Cushion Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1642.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-ECU-YG_0_3x_jpg_8aa48f70-2413-43de-892b-ef27a01136ca.webp?v=1785218459",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915949113462",
            "availableForSale": true,
            "price": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-ECU-YG_0_3x_jpg_8aa48f70-2413-43de-892b-ef27a01136ca.webp?v=1785218459",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1642.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2377.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "43818000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214773825654",
          "title": "The Margot Set With A Elongated Cushion Lab Diamond",
          "handle": "the-margot-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1692.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-ECU-YG_0_c6f66db0-6d71-4073-b7bd-0e448565e6c5.jpg?v=1785218641",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915993645174",
            "availableForSale": true,
            "price": {
              "amount": "1692.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-ECU-YG_0_c6f66db0-6d71-4073-b7bd-0e448565e6c5.jpg?v=1785218641",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1692.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2449.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "45152000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214775890038",
          "title": "The Victoria Set With A Elongated Cushion Lab Diamond",
          "handle": "the-victoria-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1692.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-ECU-YG_0_3x_jpg.webp?v=1785218702",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916003836022",
            "availableForSale": true,
            "price": {
              "amount": "1692.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-ECU-YG_0_3x_jpg.webp?v=1785218702",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1692.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2449.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "45152000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214781919350",
          "title": "The Eve Set With A Elongated Cushion Lab Diamond",
          "handle": "the-eve-setting-elongated-cushion-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1742.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/224Q-ER-ECU-YG_0_3x_jpg_cdb73e6e-ea24-478a-bded-5b5e7e5bab0b.webp?v=1785218884",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916032573558",
            "availableForSale": true,
            "price": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/224Q-ER-ECU-YG_0_3x_jpg_cdb73e6e-ea24-478a-bded-5b5e7e5bab0b.webp?v=1785218884",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2522.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "46486000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214786015350",
          "title": "The Scarlett Set With A Elongated Cushion Lab Diamond",
          "handle": "the-scarlett-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1742.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/221Q-ER-ECU-YG_0_7c4ab324-2be4-4258-a3c8-12addc1b0b0b_3x_jpg.webp?v=1785219005",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916050989174",
            "availableForSale": true,
            "price": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/221Q-ER-ECU-YG_0_7c4ab324-2be4-4258-a3c8-12addc1b0b0b_3x_jpg.webp?v=1785219005",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2522.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "46486000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214788276342",
          "title": "The Sandra Set With A Elongated Cushion Lab Diamond",
          "handle": "the-sandra-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1742.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/411Q-ER-ECU-YG_0.jpg?v=1785219065",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916060622966",
            "availableForSale": true,
            "price": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/411Q-ER-ECU-YG_0.jpg?v=1785219065",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2522.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "46486000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214777790582",
          "title": "The Natalie Set With A Elongated Cushion Lab Diamond",
          "handle": "the-natalie-setting-elongated-cushion-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1742.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/2Q-ER-ECU-YG_0_3x_jpg_2e87d7b0-e8b7-4ef7-b2fe-529fe6c90b5f.webp?v=1785218765",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916014256246",
            "availableForSale": true,
            "price": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/2Q-ER-ECU-YG_0_3x_jpg_2e87d7b0-e8b7-4ef7-b2fe-529fe6c90b5f.webp?v=1785218765",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2522.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "46486000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214783885430",
          "title": "The Pave Ashley Set With A Elongated Cushion Lab Diamond",
          "handle": "the-ashley-setting-elongated-cushion-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1742.5",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-ECU-YG_0_3x_jpg_b1c74eb2-87b7-4f74-85b4-e96746cd157e.webp?v=1785218945",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916041650294",
            "availableForSale": true,
            "price": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-ECU-YG_0_3x_jpg_b1c74eb2-87b7-4f74-85b4-e96746cd157e.webp?v=1785218945",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1742.5",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2522.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "46486000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Emerald": {
      "generatedAt": 1785812887535,
      "total": 102,
      "products": [
        {
          "id": "gid://shopify/Product/8214747054198",
          "title": "The Eleanor Set With A Emerald Lab Diamond",
          "handle": "the-eleanor-setting-emerald-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-EM-YG_0_3x_jpg_5ae03379-69a9-4116-b2cf-1f755f87d442.webp?v=1785217884",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915842617462",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-EM-YG_0_3x_jpg_5ae03379-69a9-4116-b2cf-1f755f87d442.webp?v=1785217884",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214783950966",
          "title": "The Pave Ashley Set With A Emerald Lab Diamond",
          "handle": "the-ashley-setting-emerald-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-EM-YG_0_3x_jpg_fb90086e-b07b-4423-8024-4f8df24dc81d.webp?v=1785218951",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916042502262",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-EM-YG_0_3x_jpg_fb90086e-b07b-4423-8024-4f8df24dc81d.webp?v=1785218951",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214734045302",
          "title": "The Ashley Set With A Emerald Lab Diamond",
          "handle": "the-ashley-setting-emerald-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-EM-YG_0_3x_jpg_a57b34c9-34d1-4d13-aea3-a1dcef1c1b3b.webp?v=1785217471",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915812601974",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-EM-YG_0_3x_jpg_a57b34c9-34d1-4d13-aea3-a1dcef1c1b3b.webp?v=1785217471",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214823534710",
          "title": "The Pave Eleanor Set With A Emerald Lab Diamond",
          "handle": "the-eleanor-setting-emerald-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-EM-YG_0_3x_jpg_18862ee8-6c36-4882-b28e-232dcea6f7b5.webp?v=1785220126",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916214730870",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-EM-YG_0_3x_jpg_18862ee8-6c36-4882-b28e-232dcea6f7b5.webp?v=1785220126",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214796664950",
          "title": "The Pave Lexie Set With A Emerald Lab Diamond",
          "handle": "the-lexie-setting-emerald-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-EM-YG_0_3x_jpg_9bd2f312-9965-4cf0-bbda-88708a34ab9e.webp?v=1785219322",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916101058678",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-EM-YG_0_3x_jpg_9bd2f312-9965-4cf0-bbda-88708a34ab9e.webp?v=1785219322",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214744989814",
          "title": "The Lexie Set With A Emerald Lab Diamond",
          "handle": "the-lexie-setting-emerald-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-EM-YG_0_1bec7047-2fca-45e4-9d5f-42052327ee47.webp?v=1785217825",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915833311350",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-EM-YG_0_1bec7047-2fca-45e4-9d5f-42052327ee47.webp?v=1785217825",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214749151350",
          "title": "The Alison Set With A Emerald Lab Diamond",
          "handle": "the-alison-setting-emerald-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-EM-YG_0_3x_jpg_d76426d9-8c24-46bb-acf5-c93f034f5b89.webp?v=1785217942",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915851956342",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-EM-YG_0_3x_jpg_d76426d9-8c24-46bb-acf5-c93f034f5b89.webp?v=1785217942",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214825435254",
          "title": "The Pave Alison Set With A Emerald Lab Diamond",
          "handle": "the-alison-setting-emerald-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-EM-YG_0_3x_jpg_6a481483-e26b-49c7-8d23-38ff0ddaa126.webp?v=1785220187",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916223873142",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-EM-YG_0_3x_jpg_6a481483-e26b-49c7-8d23-38ff0ddaa126.webp?v=1785220187",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214755311734",
          "title": "The Twig Set With A Emerald Lab Diamond",
          "handle": "the-twig-setting-emerald-polished-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-EM-YG_0_3x_jpg_e9500425-81af-4684-a2ba-eff6fb6c7767.webp?v=1785218117",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915882987638",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-EM-YG_0_3x_jpg_e9500425-81af-4684-a2ba-eff6fb6c7767.webp?v=1785218117",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214753247350",
          "title": "The Kamellie Set With A Emerald Lab Diamond",
          "handle": "the-kamellie-setting-emerald-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-EM-YG_0_3x_jpg_0ac75a0e-d7c7-423b-97f9-f34a8210996a.webp?v=1785218058",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915873124470",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-EM-YG_0_3x_jpg_0ac75a0e-d7c7-423b-97f9-f34a8210996a.webp?v=1785218058",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214832545910",
          "title": "The Halo Twig Set With A Emerald Lab Diamond",
          "handle": "the-twig-setting-emerald-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-EM-YG_0_3x_jpg_2e5f4705-927c-430f-9312-f885da725bb8.webp?v=1785220371",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916254576758",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-EM-YG_0_3x_jpg_2e5f4705-927c-430f-9312-f885da725bb8.webp?v=1785220371",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214867968118",
          "title": "The Pave Twig Set With A Emerald Lab Diamond",
          "handle": "the-twig-setting-emerald-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-EM-YG_0_3x_jpg_b5fe61d8-89b0-4596-ae4e-def90e1e18d8.webp?v=1785221399",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916438274166",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-EM-YG_0_3x_jpg_b5fe61d8-89b0-4596-ae4e-def90e1e18d8.webp?v=1785221399",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214833594486",
          "title": "The Pave Kamellie Set With A Emerald Lab Diamond",
          "handle": "the-kamellie-setting-emerald-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-EM-YG_0_3x_jpg_e6f2a9e4-44b1-448b-bb46-b1ad47de921a.webp?v=1785220432",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916263686262",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-EM-YG_0_3x_jpg_e6f2a9e4-44b1-448b-bb46-b1ad47de921a.webp?v=1785220432",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214771564662",
          "title": "The Textured Twig Set With A Emerald Lab Diamond",
          "handle": "the-twig-setting-emerald-textured-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-EM-YG_0_3x_jpg_595a1319-48e7-49d9-a4e0-e8293276b75b.webp?v=1785218586",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915976573046",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-EM-YG_0_3x_jpg_595a1319-48e7-49d9-a4e0-e8293276b75b.webp?v=1785218586",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214872391798",
          "title": "The Three Stone Twig Set With A Emerald Lab Diamond",
          "handle": "the-twig-setting-emerald-three-stone-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-EM-YG_0_cfc7c965-fd26-4bc5-8397-076f8593649f.jpg?v=1785221458",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916456886390",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-EM-YG_0_cfc7c965-fd26-4bc5-8397-076f8593649f.jpg?v=1785221458",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214847979638",
          "title": "The Pave Sarah Set With A Emerald Lab Diamond",
          "handle": "the-sarah-setting-emerald-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1398.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-EM-YG_0_89487baf-399f-4a0e-9b54-4f6198e1adfd.jpg?v=1785220862",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916338921590",
            "availableForSale": true,
            "price": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-EM-YG_0_89487baf-399f-4a0e-9b54-4f6198e1adfd.jpg?v=1785220862",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2023.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37296000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214757277814",
          "title": "The Sarah Set With A Emerald Lab Diamond",
          "handle": "the-sarah-setting-emerald-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1398.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-EM-YG_0_3x_jpg_72653892-cf29-4938-b688-f8ae3c74c29d.webp?v=1785218176",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915903664246",
            "availableForSale": true,
            "price": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-EM-YG_0_3x_jpg_72653892-cf29-4938-b688-f8ae3c74c29d.webp?v=1785218176",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2023.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37296000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214758817910",
          "title": "The Penelope Set With A Emerald Lab Diamond",
          "handle": "the-penelope-setting-emerald-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-EM-YG_0_3x_jpg_2f4624cf-7d04-4ffa-aab7-c4383afb4689.webp?v=1785218233",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915913396342",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-EM-YG_0_3x_jpg_2f4624cf-7d04-4ffa-aab7-c4383afb4689.webp?v=1785218233",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214762684534",
          "title": "The Razor Kamellie Set With A Emerald Lab Diamond",
          "handle": "the-razor-kamellie-setting-emerald-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-EM-YG_0_3x_jpg_b3238056-5306-4adb-8160-c70c5c4139f6.webp?v=1785218353",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915933024374",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-EM-YG_0_3x_jpg_b3238056-5306-4adb-8160-c70c5c4139f6.webp?v=1785218353",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214835658870",
          "title": "The Hidden Halo Penelope Set With A Emerald Lab Diamond",
          "handle": "the-penelope-setting-emerald-hidden-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/216Q-ER-EM-YG_0_3x_jpg_ab5b0e96-b095-4a5f-a078-5657fd906252.webp?v=1785220495",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916274204790",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/216Q-ER-EM-YG_0_3x_jpg_ab5b0e96-b095-4a5f-a078-5657fd906252.webp?v=1785220495",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214760783990",
          "title": "The Nelly Set With A Emerald Lab Diamond",
          "handle": "the-nelly-setting-emerald-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-EM-YG_0_3x_jpg_fe459d39-5275-42bf-af69-083f18df1051.webp?v=1785218292",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915923685494",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-EM-YG_0_3x_jpg_fe459d39-5275-42bf-af69-083f18df1051.webp?v=1785218292",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214854271094",
          "title": "The Pave Nelly Set With A Emerald Lab Diamond",
          "handle": "the-nelly-setting-emerald-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-EM-YG_0_3x_jpg_f27d7e3b-4650-4915-9b0a-af5b36da3bcd.webp?v=1785221031",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916370968694",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-EM-YG_0_3x_jpg_f27d7e3b-4650-4915-9b0a-af5b36da3bcd.webp?v=1785221031",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Marquise": {
      "generatedAt": 1785812887535,
      "total": 102,
      "products": [
        {
          "id": "gid://shopify/Product/8214741385334",
          "title": "The Ashley Set With A Marquise Lab Diamond",
          "handle": "the-ashley-setting-marquise-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-MQ-YG_0_3x_jpg_be3a6d18-f456-4696-ac36-effec0bdff6d.webp?v=1785217722",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915824693366",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-MQ-YG_0_3x_jpg_be3a6d18-f456-4696-ac36-effec0bdff6d.webp?v=1785217722",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214747185270",
          "title": "The Eleanor Set With A Marquise Lab Diamond",
          "handle": "the-eleanor-setting-marquise-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-MQ-YG_0_3x_jpg_b6372c28-c5e2-4d20-8aaf-c320817b06b9.webp?v=1785217902",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915845107830",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-MQ-YG_0_3x_jpg_b6372c28-c5e2-4d20-8aaf-c320817b06b9.webp?v=1785217902",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214785130614",
          "title": "The Pave Ashley Set With A Marquise Lab Diamond",
          "handle": "the-ashley-setting-marquise-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-MQ-YG_0_3x_jpg_7fbbe8aa-9369-4968-a97b-f7947618e9c4.webp?v=1785218971",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916046041206",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-MQ-YG_0_3x_jpg_7fbbe8aa-9369-4968-a97b-f7947618e9c4.webp?v=1785218971",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214825173110",
          "title": "The Pave Eleanor Set With A Marquise Lab Diamond",
          "handle": "the-eleanor-setting-marquise-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-MQ-YG_0_3x_jpg_26296694-b2d4-4c3d-90b3-5bffe4b787a3.webp?v=1785220146",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916218859638",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-MQ-YG_0_3x_jpg_26296694-b2d4-4c3d-90b3-5bffe4b787a3.webp?v=1785220146",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214745088118",
          "title": "The Lexie Set With A Marquise Lab Diamond",
          "handle": "the-lexie-setting-marquise-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-MQ-YG_0_0ed823ce-ede6-4339-a38b-2feb655154c4.webp?v=1785217844",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915835768950",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-MQ-YG_0_0ed823ce-ede6-4339-a38b-2feb655154c4.webp?v=1785217844",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214797811830",
          "title": "The Pave Lexie Set With A Marquise Lab Diamond",
          "handle": "the-lexie-setting-marquise-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-MQ-YG_0_3x_jpg_94c06f23-d780-4642-9ce8-4739d244c7b2.webp?v=1785219341",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916104564854",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-MQ-YG_0_3x_jpg_94c06f23-d780-4642-9ce8-4739d244c7b2.webp?v=1785219341",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214749315190",
          "title": "The Alison Set With A Marquise Lab Diamond",
          "handle": "the-alison-setting-marquise-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-MQ-YG_0_3x_jpg_0b100189-156c-4a17-8448-8993a4e43d8e.webp?v=1785217960",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915854479478",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-MQ-YG_0_3x_jpg_0b100189-156c-4a17-8448-8993a4e43d8e.webp?v=1785217960",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214827171958",
          "title": "The Pave Alison Set With A Marquise Lab Diamond",
          "handle": "the-alison-setting-marquise-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-MQ-YG_0_3x_jpg_e62eea62-42da-46b9-8626-68b0649e575c.webp?v=1785220206",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916228296822",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-MQ-YG_0_3x_jpg_e62eea62-42da-46b9-8626-68b0649e575c.webp?v=1785220206",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214753738870",
          "title": "The Kamellie Set With A Marquise Lab Diamond",
          "handle": "the-kamellie-setting-marquise-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-YG_0_3x_jpg_d6d37108-ee5f-4091-9817-69829d9d7aaa.webp?v=1785218077",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915876106358",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-YG_0_3x_jpg_d6d37108-ee5f-4091-9817-69829d9d7aaa.webp?v=1785218077",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214755967094",
          "title": "The Twig Set With A Marquise Lab Diamond",
          "handle": "the-twig-setting-marquise-polished-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-YG_0_3x_jpg_5aa37273-09bb-4f2a-bab3-91e1cda4b6d3.webp?v=1785218135",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915897634934",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-YG_0_3x_jpg_5aa37273-09bb-4f2a-bab3-91e1cda4b6d3.webp?v=1785218135",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214773137526",
          "title": "The Textured Twig Set With A Marquise Lab Diamond",
          "handle": "the-twig-setting-marquise-textured-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-YG_0_3x_jpg_805690aa-f58b-4f10-adf1-cd4de2259773.webp?v=1785218606",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915981258870",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-YG_0_3x_jpg_805690aa-f58b-4f10-adf1-cd4de2259773.webp?v=1785218606",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214833299574",
          "title": "The Halo Twig Set With A Marquise Lab Diamond",
          "handle": "the-twig-setting-marquise-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-MQ-YG_0_3x_jpg_d81fb4f4-df83-4207-9cc4-845007559944.webp?v=1785220390",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916257951862",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-MQ-YG_0_3x_jpg_d81fb4f4-df83-4207-9cc4-845007559944.webp?v=1785220390",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214835298422",
          "title": "The Pave Kamellie Set With A Marquise Lab Diamond",
          "handle": "the-kamellie-setting-marquise-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-YG_0_3x_jpg_bed8b7f0-2283-464e-9a29-fa1163377cd7.webp?v=1785220452",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916268994678",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-YG_0_3x_jpg_bed8b7f0-2283-464e-9a29-fa1163377cd7.webp?v=1785220452",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214873899126",
          "title": "The Three Stone Twig Set With A Marquise Lab Diamond",
          "handle": "the-twig-setting-marquise-three-stone-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-MQ-YG_0_db9794cb-e9fa-405f-8d52-58f5500adb49.jpg?v=1785221478",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916462653558",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-MQ-YG_0_db9794cb-e9fa-405f-8d52-58f5500adb49.jpg?v=1785221478",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214869606518",
          "title": "The Pave Twig Set With A Marquise Lab Diamond",
          "handle": "the-twig-setting-marquise-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-MQ-YG_0_3x_jpg_fbb3cf42-c0a7-4d5d-9f5d-cb8c562572fd.webp?v=1785221418",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916444467318",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-MQ-YG_0_3x_jpg_fbb3cf42-c0a7-4d5d-9f5d-cb8c562572fd.webp?v=1785221418",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214849683574",
          "title": "The Pave Sarah Set With A Marquise Lab Diamond",
          "handle": "the-sarah-setting-marquise-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1398.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-MQ-YG_0_4b2bd753-5233-4707-8298-dcc7e71bec3f.jpg?v=1785220882",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916342984822",
            "availableForSale": true,
            "price": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-MQ-YG_0_4b2bd753-5233-4707-8298-dcc7e71bec3f.jpg?v=1785220882",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2023.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37296000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214757933174",
          "title": "The Sarah Set With A Marquise Lab Diamond",
          "handle": "the-sarah-setting-marquise-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1398.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-MQ-YG_0_3x_jpg_233674d1-cd33-4e43-bdf0-5ce8d26afab6.webp?v=1785218195",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915906973814",
            "availableForSale": true,
            "price": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-MQ-YG_0_3x_jpg_233674d1-cd33-4e43-bdf0-5ce8d26afab6.webp?v=1785218195",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2023.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37296000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214767730806",
          "title": "The Low Profile Kamellie Set With A Marquise Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-marquise-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-MQ-YG_0_3x_jpg_3acf2add-8304-414c-b0aa-0d8cba07949a.webp?v=1785218484",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915953766518",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-MQ-YG_0_3x_jpg_3acf2add-8304-414c-b0aa-0d8cba07949a.webp?v=1785218484",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214856958070",
          "title": "The Low Profile Kamellie Set With A Marquise Lab Diamond",
          "handle": "the-low-profile-kamellie-setting-marquise-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-MQ-YG_0_3x_jpg_20d14707-4c35-4bfd-a033-0b4f4d8f3924.webp?v=1785221111",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916383158390",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-MQ-YG_0_3x_jpg_20d14707-4c35-4bfd-a033-0b4f4d8f3924.webp?v=1785221111",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214764028022",
          "title": "The Razor Kamellie Set With A Marquise Lab Diamond",
          "handle": "the-razor-kamellie-setting-marquise-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-MQ-YG_0_3x_jpg_4e4c1cf2-6b50-4e44-b82a-8d8fdb5ef0f1.webp?v=1785218375",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915936759926",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-MQ-YG_0_3x_jpg_4e4c1cf2-6b50-4e44-b82a-8d8fdb5ef0f1.webp?v=1785218375",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214777430134",
          "title": "The Victoria Set With A Marquise Lab Diamond",
          "handle": "the-victoria-setting-marquise-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1506.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-MQ-YG_0_3x_jpg.webp?v=1785218728",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916009963638",
            "availableForSale": true,
            "price": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-MQ-YG_0_3x_jpg.webp?v=1785218728",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2179.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "40177000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214877503606",
          "title": "The Pave Victoria Set With A Marquise Lab Diamond",
          "handle": "the-victoria-setting-marquise-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1506.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404QS-ER-MQ-YG_CAD.jpg?v=1785221537",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916480118902",
            "availableForSale": true,
            "price": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404QS-ER-MQ-YG_CAD.jpg?v=1785221537",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1506.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2179.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "40177000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Radiant": {
      "generatedAt": 1785812887535,
      "total": 105,
      "products": [
        {
          "id": "gid://shopify/Product/8214736273526",
          "title": "The Ashley Set With A Radiant Lab Diamond",
          "handle": "the-ashley-setting-radiant-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-RAD-YG_0_3x_jpg_fd13d8f5-e307-4af1-bcf1-50f52c835e28.webp?v=1785217554",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915816075382",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391Q-RAD-YG_0_3x_jpg_fd13d8f5-e307-4af1-bcf1-50f52c835e28.webp?v=1785217554",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214747086966",
          "title": "The Eleanor Set With A Radiant Lab Diamond",
          "handle": "the-eleanor-setting-radiant-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-RAD-YG_0_3x_jpg_e47f9eb1-5995-4a2e-9fc3-a67895620739.webp?v=1785217890",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915843436662",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-RAD-YG_0_3x_jpg_e47f9eb1-5995-4a2e-9fc3-a67895620739.webp?v=1785217890",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214783983734",
          "title": "The Pave Ashley Set With A Radiant Lab Diamond",
          "handle": "the-ashley-setting-radiant-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-RAD-YG_0_3x_jpg_1ef31009-8da5-45d2-8774-698d948a8809.webp?v=1785218958",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916043321462",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-RAD-YG_0_3x_jpg_1ef31009-8da5-45d2-8774-698d948a8809.webp?v=1785218958",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214824353910",
          "title": "The Pave Eleanor Set With A Radiant Lab Diamond",
          "handle": "the-eleanor-setting-radiant-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1237.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-RAD-YG_0_3x_jpg_c4060927-f85a-47df-8c45-0a33cbf4116f.webp?v=1785220133",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916216369270",
            "availableForSale": true,
            "price": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-RAD-YG_0_3x_jpg_c4060927-f85a-47df-8c45-0a33cbf4116f.webp?v=1785220133",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1237.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1790.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "33001000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214745022582",
          "title": "The Lexie Set With A Radiant Lab Diamond",
          "handle": "the-lexie-setting-radiant-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-RAD-YG_0_106f82c3-0caf-4134-97d1-9164057dcf44.webp?v=1785217831",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915834130550",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-RAD-YG_0_106f82c3-0caf-4134-97d1-9164057dcf44.webp?v=1785217831",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214796697718",
          "title": "The Pave Lexie Set With A Radiant Lab Diamond",
          "handle": "the-lexie-setting-radiant-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1280.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-RAD-YG_0_3x_jpg_4d4af977-0589-467b-9893-794137fd6df8.webp?v=1785219328",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916101877878",
            "availableForSale": true,
            "price": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-RAD-YG_0_3x_jpg_4d4af977-0589-467b-9893-794137fd6df8.webp?v=1785219328",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1280.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1852.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34148000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214749216886",
          "title": "The Alison Set With A Radiant Lab Diamond",
          "handle": "the-alison-setting-radiant-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-RAD-YG_0_3x_jpg_ca4dd0e5-8de5-4b13-868a-4e0a9d0dc670.webp?v=1785217948",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915852808310",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-RAD-YG_0_3x_jpg_ca4dd0e5-8de5-4b13-868a-4e0a9d0dc670.webp?v=1785217948",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214826451062",
          "title": "The Pave Alison Set With A Radiant Lab Diamond",
          "handle": "the-alison-setting-radiant-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1318.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-RAD-YG_0_3x_jpg_c902a7da-57e9-4ade-82ec-bb62c8c0900e.webp?v=1785220193",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916225937526",
            "availableForSale": true,
            "price": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-RAD-YG_0_3x_jpg_c902a7da-57e9-4ade-82ec-bb62c8c0900e.webp?v=1785220193",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1318.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1907.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "35161000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214753575030",
          "title": "The Kamellie Set With A Radiant Lab Diamond",
          "handle": "the-kamellie-setting-radiant-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-RAD-YG_0_3x_jpg_52ffe630-c73c-4244-b8c9-e53dd1d82f3d.webp?v=1785218064",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915874238582",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-RAD-YG_0_3x_jpg_52ffe630-c73c-4244-b8c9-e53dd1d82f3d.webp?v=1785218064",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214755573878",
          "title": "The Twig Set With A Radiant Lab Diamond",
          "handle": "the-twig-setting-radiant-polished-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-RAD-YG_0_3x_jpg_1626c9ac-82e2-42b7-a15e-a57e4c98ffab.webp?v=1785218123",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915888951414",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-RAD-YG_0_3x_jpg_1626c9ac-82e2-42b7-a15e-a57e4c98ffab.webp?v=1785218123",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214834282614",
          "title": "The Pave Kamellie Set With A Radiant Lab Diamond",
          "handle": "the-kamellie-setting-radiant-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-RAD-YG_0_3x_jpg_fd0684b0-2a36-41c5-9e62-f33582cf4dc9.webp?v=1785220439",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916266438774",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-RAD-YG_0_3x_jpg_fd0684b0-2a36-41c5-9e62-f33582cf4dc9.webp?v=1785220439",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214771597430",
          "title": "The Textured Twig Set With A Radiant Lab Diamond",
          "handle": "the-twig-setting-radiant-textured-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-RAD-YG_0_3x_jpg_8bd9b088-d7b1-416d-a24e-cb76656657c5.webp?v=1785218593",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915977392246",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-RAD-YG_0_3x_jpg_8bd9b088-d7b1-416d-a24e-cb76656657c5.webp?v=1785218593",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214832578678",
          "title": "The Halo Twig Set With A Radiant Lab Diamond",
          "handle": "the-twig-setting-radiant-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-RAD-YG_0_3x_jpg_eb925e57-1634-485a-a602-07859c0b3198.webp?v=1785220377",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916255395958",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-RAD-YG_0_3x_jpg_eb925e57-1634-485a-a602-07859c0b3198.webp?v=1785220377",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214872653942",
          "title": "The Three Stone Twig Set With A Radiant Lab Diamond",
          "handle": "the-twig-setting-radiant-three-stone-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-RAD-YG_0_3d484196-e2ae-4f4a-bb92-1ce5a75a380a.jpg?v=1785221465",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916458426486",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-RAD-YG_0_3d484196-e2ae-4f4a-bb92-1ce5a75a380a.jpg?v=1785221465",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214868230262",
          "title": "The Pave Twig Set With A Radiant Lab Diamond",
          "handle": "the-twig-setting-radiant-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1353.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-RAD-YG_0_3x_jpg_cc507635-2b66-4910-a6fd-5ee9f242724b.webp?v=1785221406",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916440240246",
            "availableForSale": true,
            "price": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-RAD-YG_0_3x_jpg_cc507635-2b66-4910-a6fd-5ee9f242724b.webp?v=1785221406",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1353.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1958.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "36095000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214757802102",
          "title": "The Sarah Set With A Radiant Lab Diamond",
          "handle": "the-sarah-setting-radiant-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1398.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-RAD-YG_0_3x_jpg_97780974-3095-4b6d-9e0b-d9d21dd9df10.webp?v=1785218182",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915904974966",
            "availableForSale": true,
            "price": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-RAD-YG_0_3x_jpg_97780974-3095-4b6d-9e0b-d9d21dd9df10.webp?v=1785218182",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2023.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37296000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214848798838",
          "title": "The Pave Sarah Set With A Radiant Lab Diamond",
          "handle": "the-sarah-setting-radiant-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1398.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-RAD-YG_0_2c2f0665-c7e9-40bc-a2a7-9ea5362433e0.jpg?v=1785220868",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916340527222",
            "availableForSale": true,
            "price": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405QS-ER-RAD-YG_0_2c2f0665-c7e9-40bc-a2a7-9ea5362433e0.jpg?v=1785220868",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1398.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2023.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "37296000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214759506038",
          "title": "The Penelope Set With A Radiant Lab Diamond",
          "handle": "the-penelope-setting-radiant-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-RAD-YG_0_3x_jpg_03d6d522-b0f4-456c-a3a5-fb91c12e845f.webp?v=1785218239",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915914870902",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-RAD-YG_0_3x_jpg_03d6d522-b0f4-456c-a3a5-fb91c12e845f.webp?v=1785218239",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214836510838",
          "title": "The Hidden Halo Penelope Set With A Radiant Lab Diamond",
          "handle": "the-penelope-setting-radiant-hidden-halo-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1443.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/216Q-ER-RAD-YG_0_3x_jpg_b84654d0-4c63-412f-b726-152b89526853.webp?v=1785220501",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916275843190",
            "availableForSale": true,
            "price": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/216Q-ER-RAD-YG_0_3x_jpg_b84654d0-4c63-412f-b726-152b89526853.webp?v=1785220501",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1443.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2088.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38496000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214761111670",
          "title": "The Nelly Set With A Radiant Lab Diamond",
          "handle": "the-nelly-setting-radiant-solitaire-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-RAD-YG_0_3x_jpg_f2529543-978d-42da-869f-c8ebbccd62e5.webp?v=1785218299",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915924799606",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-RAD-YG_0_3x_jpg_f2529543-978d-42da-869f-c8ebbccd62e5.webp?v=1785218299",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214763274358",
          "title": "The Razor Kamellie Set With A Radiant Lab Diamond",
          "handle": "the-razor-kamellie-setting-radiant-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-RAD-YG_0_3x_jpg_838b00f9-eee7-41c2-86b5-2c74bf2673f0.webp?v=1785218361",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43915934433398",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-RAD-YG_0_3x_jpg_838b00f9-eee7-41c2-86b5-2c74bf2673f0.webp?v=1785218361",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8214854303862",
          "title": "The Pave Nelly Set With A Radiant Lab Diamond",
          "handle": "the-nelly-setting-radiant-pave-lab-diamond",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1470.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-RAD-YG_0_3x_jpg_ec3ba8e1-ed85-4406-8c87-6e82b5b95ff3.webp?v=1785221037",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43916371787894",
            "availableForSale": true,
            "price": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-RAD-YG_0_3x_jpg_ec3ba8e1-ed85-4406-8c87-6e82b5b95ff3.webp?v=1785221037",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1470.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2127.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "39216000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    }
  },
  "moissanite-engagement-rings": {
    "Round": {
      "generatedAt": 1785812887535,
      "total": 135,
      "products": [
        {
          "id": "gid://shopify/Product/8212327202934",
          "title": "The Pave Ashley Set With A Round Moissanite",
          "handle": "the-ashley-set-with-a-round-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "780.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-R-WG_0_3x_jpg_53a5586f-32e1-46c6-89c1-9baa617fabec.webp?v=1785150066",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909879562358",
            "availableForSale": true,
            "price": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-R-YG_0_3x_jpg_eb1e55a3-54a5-44f7-bf58-ce272b7c6420.webp?v=1785150066",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1129.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "20809000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212151631990",
          "title": "The Lexie Set With A Round Moissanite",
          "handle": "the-lexie-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-R-WG_0_5d52a8a5-d322-4e84-9c68-fb834e6f530b.webp?v=1785138885",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909186322550",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-R-YG_0_ba1c1e6e-0bb5-4f8d-ad2b-88de95ea82e8.webp?v=1785138886",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212397129846",
          "title": "The Pave Lexie Set With A Round Moissanite",
          "handle": "the-lexie-set-with-a-round-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-R-WG_0_3x_jpg_0af2ce9e-f9c0-414d-8091-669ea3b3d000.webp?v=1785152577",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910014107766",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-R-YG_0_3x_jpg_42bc6f41-e69f-42a0-ae71-58b15bdc7284.webp?v=1785152577",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212164608118",
          "title": "The Alison Set With A Round Moissanite",
          "handle": "the-alison-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-R-WG_0_3x_jpg_4bff3b68-d53d-4f60-8cc4-947b28249485.webp?v=1785140486",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909291442294",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-R-YG_0_3x_jpg_10bfb116-2b9a-4bf8-ab8f-4189d2efb962.webp?v=1785140486",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212699840630",
          "title": "The Pave Alison Set With A Round Moissanite",
          "handle": "the-alison-set-with-a-round-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-R-WG_0_3x_jpg_e9dc99bb-d48a-40ab-a49f-f718106dd54c.webp?v=1785160117",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910616547446",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-R-YG_0_3x_jpg_9cfd7a11-ea87-4588-99b5-ccc53ff42b5f.webp?v=1785160117",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212179746934",
          "title": "The Katelyn Set With A Round Moissanite",
          "handle": "the-katelyn-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "878.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-R-WG_0_1c38d0e7-14a3-41d0-b4d8-1d71146e69be.jpg?v=1785141266",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909379948662",
            "availableForSale": true,
            "price": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-R-YG_0_d6a89c93-dfb3-4184-a616-2fc9066a7705.jpg?v=1785141266",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1271.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "23423000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212183416950",
          "title": "The Kamellie Set With A Round Moissanite",
          "handle": "the-kamellie-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-R-WG_0_3x_jpg_a2d29bc9-ca61-423f-8acb-d04162336182.webp?v=1785141855",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909408915574",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-R-YG_0_3x_jpg_3cef30f8-257e-4dd3-9183-d9619bbbdccf.webp?v=1785141855",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212189380726",
          "title": "The Twig Set With A Round Moissanite",
          "handle": "the-twig-set-with-a-round-polished-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-R-WG_0_3x_jpg_987a0bd1-75df-4f67-ab44-ef790d438174.webp?v=1785142994",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909453774966",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-R-YG_0_3x_jpg_ba07dc3a-9e43-4dde-addd-e446c8de72d1.webp?v=1785142994",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212895498358",
          "title": "The Pave Kamellie Set With A Round Moissanite",
          "handle": "the-kamellie-set-with-a-round-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-R-WG_0_3x_jpg_87fd09ec-c57f-49e0-aeeb-ae7c7fa0a5ca.webp?v=1785165917",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910975324278",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-R-YG_0_3x_jpg_fc1f7d26-43f7-4b13-aa15-d2483187bc1b.webp?v=1785165917",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213180022902",
          "title": "The Pave Twig Set With A Round Moissanite",
          "handle": "the-twig-set-with-a-round-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-R-WG_0_3x_jpg_1480006a-7d3e-40f5-b378-c04d9782e3e6.webp?v=1785174463",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911658438774",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-R-YG_0_3x_jpg_68d26c52-8c91-4fc0-b476-c6cbe189c225.webp?v=1785174463",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212831666294",
          "title": "The Halo Twig Set With A Round Moissanite",
          "handle": "the-twig-set-with-a-round-halo-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-R-WG_0_3x_jpg_b3407f3c-aa8c-4f37-8d28-047c96705fa9.webp?v=1785163842",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910866927734",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-R-YG_0_3x_jpg_b185cc02-d4bd-41a1-a5c2-4b6a6518b70f.webp?v=1785163842",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212291682422",
          "title": "The Textured Twig Set With A Round Moissanite",
          "handle": "the-twig-set-with-a-round-textured-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-R-WG_0_3x_jpg_3cf81bbb-b55f-45c8-a325-4acf7934c5ba.webp?v=1785148770",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909817270390",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-R-YG_0_3x_jpg_4adbd454-83b9-4d72-ba11-d2c6a3f0de8f.webp?v=1785148770",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213197127798",
          "title": "The Three Stone Twig Set With A Round Moissanite",
          "handle": "the-twig-set-with-a-round-three-stone-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-R-WG_0_51239eb1-a7c0-4036-8a34-f1897bdfd411.jpg?v=1785175010",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911692189814",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-R-YG_0_24875109-bc08-4a0f-9d20-9c6e9803c766.jpg?v=1785175011",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212216610934",
          "title": "The Nelly Set With A Round Moissanite",
          "handle": "the-nelly-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-R-WG_0_3x_jpg_24dd26e8-3c8b-461b-9de3-faee46241a9a.webp?v=1785145959",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909610406006",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-R-YG_0_3x_jpg_56acf573-ce63-429c-af18-7a9bd0d64197.webp?v=1785145959",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212277330038",
          "title": "The Berta Set With A Round Moissanite",
          "handle": "the-berta-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-R-WG_0_5f9aaa4d-3aed-4e8c-9920-4a2edb033cdd.jpg?v=1785148250",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909785944182",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-R-YG_0_04291d40-a009-4527-bc06-149f0eb288d0.jpg?v=1785148250",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212158546038",
          "title": "The Eleanor Set With A Round Moissanite",
          "handle": "the-eleanor-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-R-WG_0_3x_jpg_6232c712-0258-4e18-81a9-5ce0bdc00192.webp?v=1785139864",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909255069814",
            "availableForSale": true,
            "price": {
              "amount": "1500.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-R-YG_0_3x_jpg_e013ab33-cf17-4149-80de-8d5818ca82d3.webp?v=1785139863",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1500.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2171.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "40017000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213082833014",
          "title": "The Pave Alex Set With A Round Moissanite",
          "handle": "the-alex-set-with-a-round-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-R-WG_0_3x_jpg_3237aa32-e91c-43d4-97f4-ce38ca17be3b.webp?v=1785171236",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911476412534",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-R-YG_0_3x_jpg_dfc69634-a478-4b14-a2f7-a2924c064784.webp?v=1785171235",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212245414006",
          "title": "The Alex Set With A Round Moissanite",
          "handle": "the-alex-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-R-WG_0_3x_jpg_094902c8-c4f5-4d37-b1c8-e603deaf4561.webp?v=1785146650",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909707137142",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-R-YG_0_3x_jpg_2cee7308-fa9a-4a88-a289-32edc58c34b6.webp?v=1785146650",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213101052022",
          "title": "The Pave Nelly Set With A Round Moissanite",
          "handle": "the-nelly-set-with-a-round-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-R-WG_0_3x_jpg_d92548a4-7b0c-4d7f-aed8-eb5ed37b18a5.webp?v=1785171824",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911509606518",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-R-YG_0_3x_jpg_f05477bf-378e-4236-9915-9b284ec4ee4d.webp?v=1785171824",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212200947830",
          "title": "The Low Profile Kamellie Set With A Round Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-R-WG_0_3x_jpg_24561a40-3986-497b-b493-8259492b3ca0.webp?v=1785145233",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909565382774",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-R-YG_0_3x_jpg_47de1625-1b02-40dc-89c1-c2add7c4b23d.webp?v=1785145233",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212198391926",
          "title": "The Razor Kamellie Set With A Round Moissanite",
          "handle": "the-razor-kamellie-set-with-a-round-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-R-WG_0_3x_jpg_d9285eb7-f0d7-4fc8-8656-099dc043d42c.webp?v=1785144686",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909531795574",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-R-YG_0_3x_jpg_077d719d-77d7-4a53-8d65-6145aeaa6250.webp?v=1785144686",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212668874870",
          "title": "The Pave Eleanor Set With A Round Moissanite",
          "handle": "the-eleanor-set-with-a-round-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-R-WG_0_3x_jpg_37787b56-a6c0-467a-8cd2-f00af202754d.webp?v=1785159563",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910564905078",
            "availableForSale": true,
            "price": {
              "amount": "1950.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392QS-R-YG_0_3x_jpg_b682de75-eae7-4498-8b41-315b4691f4c1.webp?v=1785159563",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1950.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2822.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "52022000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Oval": {
      "generatedAt": 1785812887535,
      "total": 135,
      "products": [
        {
          "id": "gid://shopify/Product/8212329431158",
          "title": "The Pave Ashley Set With A Oval Moissanite",
          "handle": "the-ashley-set-with-a-oval-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "780.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-OV-WG_0_3x_jpg_fc2c966c-e288-422d-b600-a12a63d2b4b5.webp?v=1785150169",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909887033462",
            "availableForSale": true,
            "price": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-OV-YG_0_3x_jpg_eb5f347f-cae8-4fb1-b248-4b6f6d5c8268.webp?v=1785150169",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1129.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "20809000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212152516726",
          "title": "The Lexie Set With A Oval Moissanite",
          "handle": "the-lexie-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-OV-WG_0_623a5d9f-abb7-4e46-abee-ae0b6ef1fcdd.webp?v=1785138982",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909190778998",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-OV-YG_0_377bb634-5bba-4553-a7f3-24a93064906f.webp?v=1785138982",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212398899318",
          "title": "The Pave Lexie Set With A Oval Moissanite",
          "handle": "the-lexie-set-with-a-oval-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-OV-WG_0_3x_jpg_76d23333-57a7-41c1-9fd0-366eec6fb783.webp?v=1785152712",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910017679478",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-OV-YG_0_3x_jpg_5cf99f36-b1c8-4139-991d-34876c0cfb41.webp?v=1785152712",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212166803574",
          "title": "The Alison Set With A Oval Moissanite",
          "handle": "the-alison-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-OV-WG_0_3x_jpg_0a5747c5-c337-4942-8a80-6baed753b694.webp?v=1785140577",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909308907638",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-OV-YG_0_3x_jpg_037d29dc-4e91-415e-b668-efaae450c9b5.webp?v=1785140577",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212705738870",
          "title": "The Pave Alison Set With A Oval Moissanite",
          "handle": "the-alison-set-with-a-oval-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-OV-WG_0_3x_jpg_365f26c9-a492-41f7-8660-8738b188a5a5.webp?v=1785160232",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910625165430",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-OV-YG_0_3x_jpg_48b43099-37cb-4bc7-a6d7-6cd114553271.webp?v=1785160231",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212181549174",
          "title": "The Katelyn Set With A Oval Moissanite",
          "handle": "the-katelyn-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "878.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-OV-WG_0_af6a5e0e-50cb-47d5-a5fc-716b6aacb625.jpg?v=1785141343",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909392367734",
            "availableForSale": true,
            "price": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-OV-YG_0_26738096-2414-42b8-aba8-0e78118dc9f1.jpg?v=1785141343",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1271.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "23423000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212194132086",
          "title": "The Twig Set With A Oval Moissanite",
          "handle": "the-twig-set-with-a-oval-polished-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-OV-WG_0_3x_jpg_a236c0b0-85d1-4a4d-aec7-d99fb645d535.webp?v=1785143188",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909469372534",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-OV-YG_0_3x_jpg_8ace4ae8-daf6-4a6b-a575-26769556e5a1.webp?v=1785143188",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212183679094",
          "title": "The Kamellie Set With A Oval Moissanite",
          "handle": "the-kamellie-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-OV-WG_0_3x_jpg_9672327b-c1e1-4f82-a70f-fc78fd349f46.webp?v=1785141967",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909428838518",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-OV-YG_0_3x_jpg_1c740f6a-4142-4326-8490-d6c5749a0ffc.webp?v=1785141967",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212836548726",
          "title": "The Halo Twig Set With A Oval Moissanite",
          "handle": "the-twig-set-with-a-oval-halo-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-OV-WG_0_3x_jpg_046190c5-0680-4c56-b351-8975bd65cea9.webp?v=1785163968",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910874660982",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-OV-YG_0_3x_jpg_d38cc368-9833-461c-967b-8cf52694b5f2.webp?v=1785163968",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212297154678",
          "title": "The Textured Twig Set With A Oval Moissanite",
          "handle": "the-twig-set-with-a-oval-textured-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-OV-WG_0_3x_jpg_c9c691d6-e8e4-4e4a-a893-19a801332a78.webp?v=1785148993",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909824577654",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-OV-YG_0_3x_jpg_8d7b090a-d0a5-47ec-83b7-ab8c6a1e00fc.webp?v=1785148993",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213181988982",
          "title": "The Pave Twig Set With A Oval Moissanite",
          "handle": "the-twig-set-with-a-oval-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-OV-WG_0_3x_jpg_b15f7f7f-046e-4c91-a5c2-88fec17c0ce5.webp?v=1785174527",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911662567542",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-OV-YG_0_3x_jpg_0a3dd38f-6e0f-4a5d-83da-e6454e14130b.webp?v=1785174527",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212904149110",
          "title": "The Pave Kamellie Set With A Oval Moissanite",
          "handle": "the-kamellie-set-with-a-oval-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-OV-WG_0_3x_jpg_59e6c012-fbb4-4a57-898b-d292890e1ced.webp?v=1785166097",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911001899126",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-OV-YG_0_3x_jpg_5eea412a-8d90-45f5-a450-8342c7ae3771.webp?v=1785166097",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213198372982",
          "title": "The Three Stone Twig Set With A Oval Moissanite",
          "handle": "the-twig-set-with-a-oval-three-stone-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-OV-WG_0_3c0d58ec-c4d5-4463-8a91-9ffdb0db3314.jpg?v=1785175063",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911696482422",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-OV-YG_0_0a5d846c-19e6-491e-a383-87515fcc04fc.jpg?v=1785175062",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212221132918",
          "title": "The Nelly Set With A Oval Moissanite",
          "handle": "the-nelly-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-OV-WG_0_3x_jpg_460443f9-27b8-42ce-88e4-017fd2303afb.webp?v=1785146027",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909620760694",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-OV-YG_0_3x_jpg_9b6bc6cc-89d5-479f-b7cb-b59c670477ea.webp?v=1785146027",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212279033974",
          "title": "The Berta Set With A Oval Moissanite",
          "handle": "the-berta-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-OV-WG_0_4bccb211-875b-41ad-a5e0-76f1d410296b.jpg?v=1785148330",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909789319286",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-OV-YG_0_7b71f29c-7a52-4086-bd62-5f879e626cf0.jpg?v=1785148330",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212247380086",
          "title": "The Alex Set With A Oval Moissanite",
          "handle": "the-alex-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-OV-WG_0_3x_jpg_0accae27-8059-4f2d-a1a8-7bb2d09fcb68.webp?v=1785146698",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909717360758",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-OV-YG_0_3x_jpg_1650d792-a2fe-44a5-bcf9-be137627a2b9.webp?v=1785146698",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213102887030",
          "title": "The Pave Nelly Set With A Oval Moissanite",
          "handle": "the-nelly-set-with-a-oval-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-OV-WG_0_3x_jpg_2c719478-8b4c-40eb-971d-e3df7382bef1.webp?v=1785171904",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911512719478",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-OV-YG_0_3x_jpg_2f42b8c6-689a-4058-8b1d-fb2bf0ffa45a.webp?v=1785171904",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213087420534",
          "title": "The Pave Alex Set With A Oval Moissanite",
          "handle": "the-alex-set-with-a-oval-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-OV-WG_0_3x_jpg_c7f44eb9-8ee4-4cab-a41b-3ac53488d479.webp?v=1785171323",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911482245238",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-OV-YG_0_3x_jpg_e4985bba-7cba-4de7-9ca3-641e6d842d4d.webp?v=1785171323",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212198555766",
          "title": "The Razor Kamellie Set With A Oval Moissanite",
          "handle": "the-razor-kamellie-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-OV-WG_0_3x_jpg_adf7ad1f-6aa1-4c49-8227-8d6b6241146d.webp?v=1785144739",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909534122102",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-OV-YG_0_3x_jpg_922731b7-852e-4077-a198-1fe72a3feb20.webp?v=1785144739",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212201275510",
          "title": "The Low Profile Kamellie Set With A Oval Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-OV-WG_0_3x_jpg_d6c5a24b-12fd-401c-bc92-96ea844e96ad.webp?v=1785145288",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909567152246",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-OV-YG_0_3x_jpg_5ad0907c-5535-4849-996c-230fd9ec60e9.webp?v=1785145287",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213118746742",
          "title": "The Low Profile Kamellie Set With A Oval Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-oval-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-OV-WG_0_3x_jpg_5676e28f-8a56-4297-a7ac-90b4282ca296.webp?v=1785172431",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911544864886",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-OV-YG_0_3x_jpg_ab584d20-3acc-4804-9595-05452ed3d700.webp?v=1785172431",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212485275766",
          "title": "The Victoria Set With A Oval Moissanite",
          "handle": "the-victoria-set-with-a-oval-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-OV-WG_0_3x_jpg_e8819721-43af-454b-a815-0d78c4decb2c.webp?v=1785156022",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910205898870",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-OV-YG_0_3x_jpg_76ee9c80-cbef-40df-a166-505c3979cf27.webp?v=1785156021",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Pear": {
      "generatedAt": 1785812887535,
      "total": 135,
      "products": [
        {
          "id": "gid://shopify/Product/8212332478582",
          "title": "The Pave Ashley Set With A Pear Moissanite",
          "handle": "the-ashley-set-with-a-pear-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "780.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-PS-WG_0_3x_jpg_e8b2f67d-b68d-46ef-82ca-ac925827ef8b.webp?v=1785150289",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909891194998",
            "availableForSale": true,
            "price": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-PS-YG_0_3x_jpg_a8e1a9f5-fd39-44c4-85f1-f07cc631feeb.webp?v=1785150289",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1129.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "20809000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212154417270",
          "title": "The Lexie Set With A Pear Moissanite",
          "handle": "the-lexie-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-PS-WG_0_32550778-0f05-4a79-ab9d-8473dcedacbd.webp?v=1785139126",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909194547318",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-PS-YG_0_c4a7bd99-0ff8-477d-b9ae-9f87c36dc02c.webp?v=1785139126",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212398178422",
          "title": "The Pave Lexie Set With A Pear Moissanite",
          "handle": "the-lexie-set-with-a-pear-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-PS-WG_0_3x_jpg_aab0b5ea-98cb-4c15-b026-c29182bb395b.webp?v=1785152654",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910016106614",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-PS-YG_0_3x_jpg_cd265a15-5aa5-4a7b-8a23-23d01c64b2f9.webp?v=1785152655",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212172865654",
          "title": "The Alison Set With A Pear Moissanite",
          "handle": "the-alison-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-PS-WG_0_3x_jpg_b59e68ff-88d4-4623-ad05-3e2a49955ade.webp?v=1785140806",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909342920822",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-PS-YG_0_3x_jpg_638c2f5e-d80f-4694-b393-0d0a8c7343b7.webp?v=1785140806",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212703117430",
          "title": "The Pave Alison Set With A Pear Moissanite",
          "handle": "the-alison-set-with-a-pear-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-PS-WG_0_3x_jpg_983c1c41-f5de-4793-b225-6832250f3eeb.webp?v=1785160182",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910621036662",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-PS-YG_0_3x_jpg_f542630b-ee2a-45d1-98f3-3cb9d489e963.webp?v=1785160182",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212181778550",
          "title": "The Katelyn Set With A Pear Moissanite",
          "handle": "the-katelyn-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "878.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-PS-WG_0_fa6e6c94-e66d-4bed-9554-1581afedd9ed.jpg?v=1785141437",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909396004982",
            "availableForSale": true,
            "price": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-PS-YG_0_16d8b023-ad3d-425a-be12-65c84b751c09.jpg?v=1785141436",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1271.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "23423000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212194623606",
          "title": "The Twig Set With A Pear Moissanite",
          "handle": "the-twig-set-with-a-pear-polished-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-PS-WG_0_3x_jpg_95b74012-62a7-4c7e-891f-54703a1e72b7.webp?v=1785143356",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909471371382",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-PS-YG_0_3x_jpg_352d2ce0-d3f9-4284-9238-b828fe91a934.webp?v=1785143356",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212185841782",
          "title": "The Kamellie Set With A Pear Moissanite",
          "handle": "the-kamellie-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-PS-WG_0_3x_jpg_c30303b2-8f6b-4b8f-8561-05aa4095c969.webp?v=1785142178",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909435097206",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-PS-YG_0_3x_jpg_f378b0e1-10a1-4382-a7ea-67610e1543c5.webp?v=1785142178",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212833566838",
          "title": "The Halo Twig Set With A Pear Moissanite",
          "handle": "the-twig-set-with-a-pear-halo-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-PS-WG_0_3x_jpg_7725eec5-2ef5-461b-a068-523023897bc0.webp?v=1785163899",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910870827126",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-PS-YG_0_3x_jpg_a4f14148-d803-4fdf-b28e-6034a5d05fce.webp?v=1785163898",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212293943414",
          "title": "The Textured Twig Set With A Pear Moissanite",
          "handle": "the-twig-set-with-a-pear-textured-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-PS-WG_0_3x_jpg_298cf8d8-b379-42d0-b07b-4dacd28ed9bd.webp?v=1785148881",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909820514422",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-PS-YG_0_3x_jpg_8afea543-d22d-45ef-87ea-0c43840a3cfb.webp?v=1785148881",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213184184438",
          "title": "The Pave Twig Set With A Pear Moissanite",
          "handle": "the-twig-set-with-a-pear-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-PS-WG_0_3x_jpg_e843bf59-040c-433a-a356-29dcbf5db799.webp?v=1785174611",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911667220598",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-PS-YG_0_3x_jpg_00965f50-0727-45d9-82cb-eb943016bc07.webp?v=1785174611",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212898644086",
          "title": "The Pave Kamellie Set With A Pear Moissanite",
          "handle": "the-kamellie-set-with-a-pear-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-PS-WG_0_3x_jpg_e5a8dfbd-bdea-4e01-87b1-34cf588a46bf.webp?v=1785165992",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910987415670",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-PS-YG_0_3x_jpg_ff715861-af1b-4b1f-8ab9-372a298201b2.webp?v=1785165992",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213199388790",
          "title": "The Three Stone Twig Set With A Pear Moissanite",
          "handle": "the-twig-set-with-a-pear-three-stone-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-PS-WG_0_ea793bdb-2e49-4a0a-be4c-dee6a3baba1b.jpg?v=1785175116",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911698579574",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-PS-YG_0_3a901e40-4ac3-4740-9db0-a5d1e0796139.jpg?v=1785175116",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212226670710",
          "title": "The Nelly Set With A Pear Moissanite",
          "handle": "the-nelly-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-PS-WG_0_3x_jpg_0fbe0c42-3981-4d54-8983-7d1a4d3e43ae.webp?v=1785146134",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909638455414",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-PS-YG_0_3x_jpg_8010aee8-8db7-4d23-b855-cc66e27969ce.webp?v=1785146134",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212281983094",
          "title": "The Berta Set With A Pear Moissanite",
          "handle": "the-berta-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-PS-WG_0_091e1f17-81d2-4ba2-a0c0-2b6f6633b6a6.jpg?v=1785148407",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909794234486",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-PS-YG_0_16ed2dac-3722-4967-8a9d-821305f4fcb0.jpg?v=1785148407",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212247642230",
          "title": "The Alex Set With A Pear Moissanite",
          "handle": "the-alex-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-PS-WG_0_3x_jpg_eb43e041-4d7c-4ec9-a62d-e8bc5dc8fe7d.webp?v=1785146846",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909718474870",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-PS-YG_0_3x_jpg_f8746fd4-9643-4c26-aa39-e83688012cd6.webp?v=1785146846",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212198752374",
          "title": "The Razor Kamellie Set With A Pear Moissanite",
          "handle": "the-razor-kamellie-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-PS-WG_0_3x_jpg_2d5ecd8f-3d2d-4201-9590-73629016f315.webp?v=1785144813",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909537333366",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-PS-YG_0_3x_jpg_7c7668d4-a446-4a8a-97ba-8ee822432b83.webp?v=1785144813",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213089583222",
          "title": "The Pave Alex Set With A Pear Moissanite",
          "handle": "the-alex-set-with-a-pear-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-PS-WG_0_3x_jpg_c38c68b8-a023-4b1f-a46c-d4ba99f95faa.webp?v=1785171400",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911485194358",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-PS-YG_0_3x_jpg_d236285c-5395-43d4-943d-aef2b7c7bef2.webp?v=1785171400",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213104918646",
          "title": "The Pave Nelly Set With A Pear Moissanite",
          "handle": "the-nelly-set-with-a-pear-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-PS-WG_0_3x_jpg_f4858b1d-9fc8-498a-bba7-4edc05ade18f.webp?v=1785171993",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911519895670",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-PS-YG_0_3x_jpg_a30bd1b3-90a0-4908-8c69-272d441758b6.webp?v=1785171993",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212201767030",
          "title": "The Low Profile Kamellie Set With A Pear Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-PS-WG_0_3x_jpg_1329a3e9-d5cc-4c7d-a6de-239e02a60aa1.webp?v=1785145495",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909569675382",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-PS-YG_0_3x_jpg_3ccff45a-dbd9-46dd-88be-181e57418edf.webp?v=1785145495",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213121499254",
          "title": "The Low Profile Kamellie Set With A Pear Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-pear-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-PS-WG_0_3x_jpg_891173e3-9961-4fd8-9d41-99bd01ea0f00.webp?v=1785172544",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911551451254",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-PS-YG_0_3x_jpg_898d0992-86af-4af9-8456-4442d5090aa6.webp?v=1785172544",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212484358262",
          "title": "The Victoria Set With A Pear Moissanite",
          "handle": "the-victoria-set-with-a-pear-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-PS-WG_0_3x_jpg_2bf5678c-6af0-4091-bbae-e5fc8c26d018.webp?v=1785155971",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910204194934",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-PS-YG_0_3x_jpg_c0972fd4-a963-4314-a3f6-dd63e9a3dd0c.webp?v=1785155971",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Princess": {
      "generatedAt": 1785812887535,
      "total": 128,
      "products": [
        {
          "id": "gid://shopify/Product/8212341751926",
          "title": "The Pave Ashley Set With A Princess Moissanite",
          "handle": "the-ashley-set-with-a-princess-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "780.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-PR-WG_0_3x_jpg_2147ce33-3a2a-4538-89dc-59ab19ed860b.webp?v=1785150652",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909908693110",
            "availableForSale": true,
            "price": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-PR-YG_0_3x_jpg_c2a1b118-1998-4641-8d8d-9f46a46f1774.webp?v=1785150652",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1129.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "20809000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212155236470",
          "title": "The Lexie Set With A Princess Moissanite",
          "handle": "the-lexie-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-PR-WG_0_3e0f5306-c730-4c7c-a426-a763c7a1a7aa.webp?v=1785139654",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909228527734",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-PR-YG_0_6fd3e30e-21c4-46ac-bf1f-b79f5109edaf.webp?v=1785139654",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212406173814",
          "title": "The Pave Lexie Set With A Princess Moissanite",
          "handle": "the-lexie-set-with-a-princess-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-PR-WG_0_3x_jpg_43e35af0-3811-47cf-b55d-7b0f77050ef1.webp?v=1785153023",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910029508726",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-PR-YG_0_3x_jpg_986bd829-6ea1-425b-a25a-c1f46cf145c8.webp?v=1785153023",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212179484790",
          "title": "The Alison Set With A Princess Moissanite",
          "handle": "the-alison-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-PR-WG_0_3x_jpg_c983fc94-87a3-4202-a38a-ad16923a0464.webp?v=1785141148",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909377982582",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-PR-YG_0_3x_jpg_3c102739-7e85-468c-9d80-5dceff9a7889.webp?v=1785141148",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212722286710",
          "title": "The Pave Alison Set With A Princess Moissanite",
          "handle": "the-alison-set-with-a-princess-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-PR-WG_0_3x_jpg_24c632af-b4f5-4f79-a82b-7dd35d731fb8.webp?v=1785160518",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910651052150",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-PR-YG_0_3x_jpg_d56742a6-9129-448e-8e7e-eeb1f7b4a7cf.webp?v=1785160518",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212182564982",
          "title": "The Katelyn Set With A Princess Moissanite",
          "handle": "the-katelyn-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "878.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-PR-WG_0_ad116584-a38f-402b-aae4-0bd94b93784d.jpg?v=1785141750",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909405048950",
            "availableForSale": true,
            "price": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-PR-YG_0_f9530dc2-4307-4b6e-bda9-4b412849ebf8.jpg?v=1785141750",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1271.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "23423000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212186988662",
          "title": "The Kamellie Set With A Princess Moissanite",
          "handle": "the-kamellie-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-PR-WG_0_3x_jpg_e4d7eb52-3a0d-47fe-9daf-ea842540ba9e.webp?v=1785142773",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909444010102",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-PR-YG_0_3x_jpg_7b648fb8-bbab-4912-ac1f-9a62724907bf.webp?v=1785142773",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212195704950",
          "title": "The Twig Set With A Princess Moissanite",
          "handle": "the-twig-set-with-a-princess-polished-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-PR-WG_0_3x_jpg_a5147ed3-2337-4c4d-beea-b3d845de5f3a.webp?v=1785143797",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909499682934",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-PR-YG_0_3x_jpg_5250afd7-b43f-4f38-a580-0c3b8ea2fb2b.webp?v=1785143797",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212308426870",
          "title": "The Textured Twig Set With A Princess Moissanite",
          "handle": "the-twig-set-with-a-princess-textured-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-PR-WG_0_3x_jpg_924da6a8-64ba-43b0-8e6b-4b1f8429edda.webp?v=1785149432",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909842993270",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-PR-YG_0_3x_jpg_881cf961-f08f-467a-a317-51505d3d1f25.webp?v=1785149432",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212846084214",
          "title": "The Halo Twig Set With A Princess Moissanite",
          "handle": "the-twig-set-with-a-princess-halo-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-PR-WG_0_3x_jpg_bacbac64-0dba-487f-ac78-7dc61d148a0f.webp?v=1785164273",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910889832566",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-PR-YG_0_3x_jpg_91ed9dc9-cc50-43e4-b6e5-81723351e8cb.webp?v=1785164273",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212938915958",
          "title": "The Pave Kamellie Set With A Princess Moissanite",
          "handle": "the-kamellie-set-with-a-princess-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-PR-WG_0_3x_jpg_66f37e3d-d041-4163-b18f-0f5f103d31c2.webp?v=1785166758",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911131037814",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-PR-YG_0_3x_jpg_8e83667f-f437-487c-9485-495ed5a6a057.webp?v=1785166758",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213195554934",
          "title": "The Pave Twig Set With A Princess Moissanite",
          "handle": "the-twig-set-with-a-princess-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-PR-WG_0_3x_jpg_3c4f9ed9-3c90-4698-878f-e959b5d71f40.webp?v=1785174951",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911689764982",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-PR-YG_0_3x_jpg_3d867ccd-1215-4ef7-96d9-4d7e960d6602.webp?v=1785174951",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213211447414",
          "title": "The Three Stone Twig Set With A Princess Moissanite",
          "handle": "the-twig-set-with-a-princess-three-stone-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-PR-WG_0_e1565cef-1f3d-46e6-95c5-fa45beffa60a.jpg?v=1785175508",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911721287798",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-PR-YG_0_42a2392a-92c8-4301-a7e8-10ab7133b6bf.jpg?v=1785175508",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212238467190",
          "title": "The Nelly Set With A Princess Moissanite",
          "handle": "the-nelly-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-PR-WG_0_3x_jpg_4e745c4a-05fa-4a55-abcf-74a6d38680a6.webp?v=1785146500",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909673648246",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-PR-YG_0_3x_jpg_56efe9b8-7997-4d4f-bbc9-8840d91e5a8f.webp?v=1785146500",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212289126518",
          "title": "The Berta Set With A Princess Moissanite",
          "handle": "the-berta-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-PR-WG_0_67dc997e-a237-48e5-b737-c23cab13530a.jpg?v=1785148664",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909811699830",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-PR-YG_0_0c5c5655-3071-44cd-b6e2-ded64bc965fb.jpg?v=1785148664",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212200620150",
          "title": "The Razor Kamellie Set With A Princess Moissanite",
          "handle": "the-razor-kamellie-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-PR-WG_0_3x_jpg_518f99a8-4c5b-4c05-bef9-b8f3f607262d.webp?v=1785145105",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909560467574",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-PR-YG_0_3x_jpg_9525d081-60c8-4a8c-9fb1-602d5b7f425f.webp?v=1785145105",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213115666550",
          "title": "The Pave Nelly Set With A Princess Moissanite",
          "handle": "the-nelly-set-with-a-princess-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-PR-WG_0_3x_jpg_d44a8291-1eb4-47ab-9d0a-f5e8abb7ddc8.webp?v=1785172332",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911538507894",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-PR-YG_0_3x_jpg_19b6d843-c401-41bf-8d2e-1e508d0916f4.webp?v=1785172332",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212205994102",
          "title": "The Low Profile Kamellie Set With A Princess Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-PR-WG_0_3x_jpg_e7d125f2-2818-437b-ac4e-8e79d3e4460d.webp?v=1785145830",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909580324982",
            "availableForSale": true,
            "price": {
              "amount": "1300.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-PR-YG_0_3x_jpg_c0ac2764-15bb-4950-8cf1-715026f5435d.webp?v=1785145831",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1300.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1881.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34681000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213132476534",
          "title": "The Low Profile Kamellie Set With A Princess Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-princess-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-PR-WG_0_3x_jpg_fc0d51ee-e22d-47e2-b044-d9b0dbbc52da.webp?v=1785172916",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911567474806",
            "availableForSale": true,
            "price": {
              "amount": "1300.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-PR-YG_0_3x_jpg_b2a0d501-46e6-4dea-a92c-f09a08aed197.webp?v=1785172916",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1300.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1881.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "34681000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212324155510",
          "title": "The Margot Set With A Princess Moissanite",
          "handle": "the-margot-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-PR-WG_0_663bfc3b-6e55-43b5-8ae6-cefa4ad42e6c.jpg?v=1785149951",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909873008758",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-PR-YG_0_c5d92397-9766-4d76-a79d-7fea41eb3799.jpg?v=1785149951",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212496482422",
          "title": "The Victoria Set With A Princess Moissanite",
          "handle": "the-victoria-set-with-a-princess-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-PR-WG_0_3x_jpg_5ee7b976-a9b1-42ab-9346-87b4e2caddb1.webp?v=1785156407",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910222184566",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-PR-YG_0_3x_jpg_bc9cc497-d708-4dbe-8a6f-cb1c180b5d41.webp?v=1785156407",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213178187894",
          "title": "The Pave Margot Set With A Princess Moissanite",
          "handle": "the-margot-set-with-a-princess-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412QS-ER-PR-WG_0_07284896-e19e-4b3b-a9e2-55bd80908026.jpg?v=1785174423",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911655391350",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412QS-ER-PR-YG_0_8bd52eab-00f5-4d87-a9cd-0241318119c7.jpg?v=1785174423",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Cushion": {
      "generatedAt": 1785812887535,
      "total": 135,
      "products": [
        {
          "id": "gid://shopify/Product/8212333887606",
          "title": "The Pave Ashley Set With A Cushion Moissanite",
          "handle": "the-ashley-set-with-a-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "780.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-CU-WG_0_3x_jpg_01507b6a-c1a3-4bae-aa3d-a83534fb85fc.webp?v=1785150347",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909893423222",
            "availableForSale": true,
            "price": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-CU-YG_0_3x_jpg_340ea0b0-e464-4f57-8fcc-810a3abbcf85.webp?v=1785150347",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1129.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "20809000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212154581110",
          "title": "The Lexie Set With A Cushion Moissanite",
          "handle": "the-lexie-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-CU-WG_0_7589cbc9-39af-4739-a8c7-b065f0fc6547.webp?v=1785139209",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909214666870",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-CU-YG_0_45d7a4ef-dbd7-4cee-accd-f5f7ea694d7e.webp?v=1785139209",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212400767094",
          "title": "The Pave Lexie Set With A Cushion Moissanite",
          "handle": "the-lexie-set-with-a-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-CU-WG_0_3x_jpg_a5df3236-d2c6-4ffe-9f6b-50ed7d48ac1a.webp?v=1785152817",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910020366454",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-CU-YG_0_3x_jpg_641378f3-03f7-4c57-85e6-29b9dab331cc.webp?v=1785152816",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212174798966",
          "title": "The Alison Set With A Cushion Moissanite",
          "handle": "the-alison-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-CU-WG_0_3x_jpg_26a4f7fb-c7c8-43f0-b13f-df81cf3d0d88.webp?v=1785140890",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909352816758",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-CU-YG_0_3x_jpg_dd535209-d39b-42a6-bdf2-a92f57c2f040.webp?v=1785140890",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212709277814",
          "title": "The Pave Alison Set With A Cushion Moissanite",
          "handle": "the-alison-set-with-a-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-CU-WG_0_3x_jpg_a386071b-a39f-4d8f-84f8-a963c5644d02.webp?v=1785160292",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910630768758",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-CU-YG_0_3x_jpg_8d00912d-f262-494c-889d-7fb7854df6d6.webp?v=1785160292",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212182040694",
          "title": "The Katelyn Set With A Cushion Moissanite",
          "handle": "the-katelyn-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "878.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-CU-WG_0_0d17fc74-19f8-45ac-8bb5-05ef9fd30ff7.jpg?v=1785141501",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909398298742",
            "availableForSale": true,
            "price": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-CU-YG_0_3d6798f2-c763-42ea-bed7-dd1c0d09d419.jpg?v=1785141501",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1271.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "23423000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212185874550",
          "title": "The Kamellie Set With A Cushion Moissanite",
          "handle": "the-kamellie-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-CU-WG_0_3x_jpg_76c1ef5d-5bb4-4181-920e-5c3b262e5f29.webp?v=1785142253",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909435916406",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-CU-YG_0_3x_jpg_207beb56-8dd5-4844-a33e-918eeba50d04.webp?v=1785142253",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212194918518",
          "title": "The Twig Set With A Cushion Moissanite",
          "handle": "the-twig-set-with-a-cushion-polished-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-CU-WG_0_3x_jpg_6fcee92b-4690-4d37-93e3-67509fdc0a48.webp?v=1785143474",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909489557622",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-CU-YG_0_3x_jpg_5ae45be0-a3de-46c5-915d-831c7372e4a6.webp?v=1785143473",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213186117750",
          "title": "The Pave Twig Set With A Cushion Moissanite",
          "handle": "the-twig-set-with-a-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-CU-WG_0_3x_jpg_9c9e6ba2-725b-4ad5-8c60-d3ae6ba2bb83.webp?v=1785174667",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911670923382",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-CU-YG_0_3x_jpg_78a43ace-2e96-4c3c-9e4e-8b8672b4320b.webp?v=1785174667",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212914503798",
          "title": "The Pave Kamellie Set With A Cushion Moissanite",
          "handle": "the-kamellie-set-with-a-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-CU-WG_0_3x_jpg_189a3cf2-bbf2-4d82-917e-2835d8304fd3.webp?v=1785166284",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911045939318",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-CU-YG_0_3x_jpg_efc4aa3f-e691-4869-a2fe-dd440488d8b6.webp?v=1785166284",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212838908022",
          "title": "The Halo Twig Set With A Cushion Moissanite",
          "handle": "the-twig-set-with-a-cushion-halo-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-CU-WG_0_3x_jpg_6986890e-a608-4115-9d41-0066fdfa36d9.webp?v=1785164049",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910878232694",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-CU-YG_0_3x_jpg_a7b196fd-5d89-4b78-889d-4a6f246bc1c3.webp?v=1785164049",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213201158262",
          "title": "The Three Stone Twig Set With A Cushion Moissanite",
          "handle": "the-twig-set-with-a-cushion-three-stone-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-CU-WG_0_d8dbea8d-4b68-4fee-98de-15c804afab57.jpg?v=1785175182",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911701364854",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-CU-YG_0_33cd63da-98ff-4970-a0ac-c7ae1880bc1c.jpg?v=1785175182",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212302069878",
          "title": "The Textured Twig Set With A Cushion Moissanite",
          "handle": "the-twig-set-with-a-cushion-textured-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-CU-WG_0_3x_jpg_a164468b-1e7b-4b3a-a11c-7278e6fcef59.webp?v=1785149161",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909831950454",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-CU-YG_0_3x_jpg_f4f3e191-79e6-4726-98b0-4e69d0acdceb.webp?v=1785149161",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212230144118",
          "title": "The Nelly Set With A Cushion Moissanite",
          "handle": "the-nelly-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-CU-WG_0_3x_jpg_1f6d4b5b-9ca7-46e0-b04e-978f8407bf7e.webp?v=1785146205",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909645402230",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-CU-YG_0_3x_jpg_32940f80-e351-4733-8c4f-f544f9890453.webp?v=1785146206",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212248166518",
          "title": "The Alex Set With A Cushion Moissanite",
          "handle": "the-alex-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-CU-WG_0_3x_jpg_4a49c421-cd77-4c66-9cc7-2f257b79ea1b.webp?v=1785146904",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909723291766",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-CU-YG_0_3x_jpg_9d0c0772-5373-4199-aa9a-bed1769dc041.webp?v=1785146904",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213106753654",
          "title": "The Pave Nelly Set With A Cushion Moissanite",
          "handle": "the-nelly-set-with-a-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-CU-WG_0_3x_jpg_c0ef6c85-5b35-45be-b75c-8f0f680debab.webp?v=1785172040",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911522484342",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-CU-YG_0_3x_jpg_190c1d4a-4b48-4572-ae8e-4d7afb5b3379.webp?v=1785172040",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212199112822",
          "title": "The Razor Kamellie Set With A Cushion Moissanite",
          "handle": "the-razor-kamellie-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-CU-WG_0_3x_jpg_a9de4963-4749-4d0c-badd-8fed44b9debe.webp?v=1785144860",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909542609014",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-CU-YG_0_3x_jpg_7f8e210e-0b3a-4170-af36-8f58bf5a621d.webp?v=1785144860",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212282835062",
          "title": "The Berta Set With A Cushion Moissanite",
          "handle": "the-berta-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-CU-WG_0_7d66dbec-abe9-4e90-b7b5-22355cf48593.jpg?v=1785148458",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909796528246",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-CU-YG_0_bbb3ebdb-06c6-4f89-a612-020c78f11b32.jpg?v=1785148458",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213091319926",
          "title": "The Pave Alex Set With A Cushion Moissanite",
          "handle": "the-alex-set-with-a-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-CU-WG_0_3x_jpg_cf2b861f-7b00-4f6f-bc1f-921b6139b1b2.webp?v=1785171483",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911489126518",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-CU-YG_0_3x_jpg_00104d0f-1873-4c7e-9dfc-8d42b6f0052c.webp?v=1785171483",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212201898102",
          "title": "The Low Profile Kamellie Set With A Cushion Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-CU-WG_0_3x_jpg_863a4ca8-d5f3-45bb-b46e-c77a74da8c8b.webp?v=1785145551",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909571149942",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-CU-YG_0_3x_jpg_05a74d4f-00ea-46fe-a4b9-6a69b7122197.webp?v=1785145551",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213123039350",
          "title": "The Low Profile Kamellie Set With A Cushion Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-CU-WG_0_3x_jpg_7dd833ef-c539-41e0-985b-31022a71972c.webp?v=1785172595",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911553745014",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-CU-YG_0_3x_jpg_b28b4713-e1f3-49ab-bfa9-e5f12e77e5e3.webp?v=1785172595",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212317241462",
          "title": "The Margot Set With A Cushion Moissanite",
          "handle": "the-margot-set-with-a-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-CU-WG_0_218b9c30-9efa-450e-93f4-06efddb918c9.jpg?v=1785149738",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909858787446",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-CU-YG_0_94437925-0893-448a-abd5-7682a715b466.jpg?v=1785149738",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "E. Cushion": {
      "generatedAt": 1785812887535,
      "total": 134,
      "products": [
        {
          "id": "gid://shopify/Product/8212154712182",
          "title": "The Lexie Set With A Elongated Cushion Moissanite",
          "handle": "the-lexie-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1450.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-ECU-WG_0_777422bd-274c-40fa-85f3-226e62dee11e.webp?v=1785139272",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909215780982",
            "availableForSale": true,
            "price": {
              "amount": "1450.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-ECU-YG_0_b7a54798-3165-4440-ba44-9617499669ac.webp?v=1785139271",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1450.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2098.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "38683000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212176371830",
          "title": "The Alison Set With A Elongated Cushion Moissanite",
          "handle": "the-alison-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1500.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-ECU-WG_0_3x_jpg_aadeddbf-ab1d-4875-a7da-1d64eed5b8df.webp?v=1785140943",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909360091254",
            "availableForSale": true,
            "price": {
              "amount": "1500.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-ECU-YG_0_3x_jpg_52b6ef14-ce5f-4f8d-b712-817d19635016.webp?v=1785140943",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1500.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2171.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "40017000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212159299702",
          "title": "The Eleanor Set With A Elongated Cushion Moissanite",
          "handle": "the-eleanor-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1500.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-ECU-WG_0_3x_jpg_ada36515-dd42-4923-ac4c-a75f1b5f14fb.webp?v=1785140145",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909262868598",
            "availableForSale": true,
            "price": {
              "amount": "1500.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/392Q-ECU-YG_0_3x_jpg_bf7901ba-8c3c-4424-adc4-af99d5a39f7c.webp?v=1785140145",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1500.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2171.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "40017000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212182106230",
          "title": "The Katelyn Set With A Elongated Cushion Moissanite",
          "handle": "the-katelyn-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1550.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-ECU-WG_0_3827f782-bda1-4a56-afe2-781e2c1f0360.jpg?v=1785141554",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909399838838",
            "availableForSale": true,
            "price": {
              "amount": "1550.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-ECU-YG_0_9a6c0968-187c-4197-9174-0b068fd4fee0.jpg?v=1785141554",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1550.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2243.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "41351000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212195278966",
          "title": "The Twig Set With A Elongated Cushion Moissanite",
          "handle": "the-twig-set-with-a-e-cushion-polished-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1600.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-ECU-WG_0_3x_jpg_45d242fd-8056-45fa-b87d-12b486107fcc.webp?v=1785143565",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909494669430",
            "availableForSale": true,
            "price": {
              "amount": "1600.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-ECU-YG_0_3x_jpg_1b787914-2b0f-4673-807b-4cd02ae05d4b.webp?v=1785143565",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1600.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2315.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "42684000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212186071158",
          "title": "The Kamellie Set With A Elongated Cushion Moissanite",
          "handle": "the-kamellie-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1600.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-ECU-WG_0_3x_jpg_dbe479f7-bfec-4059-b46d-7add1999093b.webp?v=1785142331",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909437096054",
            "availableForSale": true,
            "price": {
              "amount": "1600.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-ECU-YG_0_3x_jpg_5321ee6c-536a-409d-8bf4-a477fb91f61f.webp?v=1785142331",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1600.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2315.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "42684000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212197212278",
          "title": "The Sarah Set With A Elongated Cushion Moissanite",
          "handle": "the-sarah-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1650.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-ECU-WG_0_3x_jpg_c840fb61-e62d-4188-b296-432fe371afa6.webp?v=1785144302",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909516755062",
            "availableForSale": true,
            "price": {
              "amount": "1650.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/405Q-ECU-YG_0_3x_jpg_a74d073b-fea4-4313-8495-8c002ca38f98.webp?v=1785144302",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1650.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2388.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "44018000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212284080246",
          "title": "The Berta Set With A Elongated Cushion Moissanite",
          "handle": "the-berta-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1700.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-ECU-WG_0_f5144434-deab-4066-83cf-755d6f49e232.jpg?v=1785148510",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909799313526",
            "availableForSale": true,
            "price": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-ECU-YG_0_b6c39348-576b-4e4f-9273-7aa226754968.jpg?v=1785148510",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2460.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "45352000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212230242422",
          "title": "The Nelly Set With A Elongated Cushion Moissanite",
          "handle": "the-nelly-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1700.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-ECU-WG_0_3x_jpg_01506b0a-21c0-44f0-90de-ed7c2858dd5c.webp?v=1785146250",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909646319734",
            "availableForSale": true,
            "price": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-ECU-YG_0_3x_jpg_fc9c7abe-4a54-49c6-9308-7e5c46f745f6.webp?v=1785146250",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2460.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "45352000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212249837686",
          "title": "The Alex Set With A Elongated Cushion Moissanite",
          "handle": "the-alex-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1700.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-ECU-WG_0_3x_jpg_d5160d84-19ec-42b0-915d-820b87c5fb68.webp?v=1785146954",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909726273654",
            "availableForSale": true,
            "price": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-ECU-YG_0_3x_jpg_d8e1d961-1277-4253-9330-717bb82e51af.webp?v=1785146954",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2460.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "45352000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212259143798",
          "title": "The Penelope Set With A Elongated Cushion Moissanite",
          "handle": "the-penelope-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1700.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-ECU-WG_0_3x_jpg_9152c7cb-f56b-482b-9f91-1acabb809fb1.webp?v=1785147718",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909753405558",
            "availableForSale": true,
            "price": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/198Q-ER-ECU-YG_0_3x_jpg_7dcbb993-a7c3-4c2c-ae6a-1b0111eb1169.webp?v=1785147718",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2460.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "45352000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212303708278",
          "title": "The Textured Twig Set With A Elongated Cushion Moissanite",
          "handle": "the-twig-set-with-a-e-cushion-textured-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1700.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-ECU-WG_0_3x_jpg_8675281c-9dbd-468e-be7f-73ba0df9d2e2.webp?v=1785149246",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909835096182",
            "availableForSale": true,
            "price": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-ECU-YG_0_3x_jpg_2c1736a5-ada2-4a85-89ba-485014de3b7f.webp?v=1785149246",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2460.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "45352000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212199833718",
          "title": "The Razor Kamellie Set With A Elongated Cushion Moissanite",
          "handle": "the-razor-kamellie-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1700.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-ECU-WG_0_3x_jpg_4a5cce87-78ac-4d5f-bf02-cde5ec4baecd.webp?v=1785144909",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909549981814",
            "availableForSale": true,
            "price": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-ECU-YG_0_3x_jpg_00e8005e-fd27-432f-afcb-6a1c0073a5ae.webp?v=1785144909",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2460.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "45352000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212202061942",
          "title": "The Low Profile Kamellie Set With A Elongated Cushion Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1700.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-ECU-WG_0_3x_jpg_80b38283-89e6-4106-b15c-9b23917b9b5d.webp?v=1785145608",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909572919414",
            "availableForSale": true,
            "price": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-ECU-YG_0_3x_jpg_53ad94f9-b219-4dcc-885b-184e2db41ba6.webp?v=1785145608",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1700.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2460.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "45352000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212319010934",
          "title": "The Margot Set With A Elongated Cushion Moissanite",
          "handle": "the-margot-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1750.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-ECU-WG_0_2c80979a-274f-4b98-9dae-833bf60f9afe.jpg?v=1785149795",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909862391926",
            "availableForSale": true,
            "price": {
              "amount": "1750.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-ECU-YG_0_6d42ddb4-eb67-42bf-9fec-7f492e3c1582.jpg?v=1785149795",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1750.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2532.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "46686000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212351615094",
          "title": "The Eve Set With A Elongated Cushion Moissanite",
          "handle": "the-eve-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1800.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/224Q-ER-ECU-WG_0_3x_jpg_5dba270f-817a-4f9a-87f8-c312b24eb9cb.webp?v=1785151006",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909926223990",
            "availableForSale": true,
            "price": {
              "amount": "1800.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/224Q-ER-ECU-YG_0_3x_jpg_c9c40659-202f-42d7-9ec2-0581526a452e.webp?v=1785151006",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1800.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2605.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "48020000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212383826038",
          "title": "The Natalie Set With A Elongated Cushion Moissanite",
          "handle": "the-natalie-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1800.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/2Q-ER-ECU-WG_0_3x_jpg_fc89bc5d-4fb2-4eff-a813-e096ec9d86f0.webp?v=1785152101",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909989826678",
            "availableForSale": true,
            "price": {
              "amount": "1800.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/2Q-ER-ECU-YG_0_3x_jpg_08af339a-f7fc-4c91-9f5c-4997ff25f8f6.webp?v=1785152101",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1800.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2605.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "48020000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212335296630",
          "title": "The Pave Ashley Set With A Elongated Cushion Moissanite",
          "handle": "the-ashley-set-with-a-e-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1800.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-ECU-WG_0_3x_jpg_136385ae-fd4a-468e-961e-bace998c5b93.webp?v=1785150418",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909895782518",
            "availableForSale": true,
            "price": {
              "amount": "1800.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-ECU-YG_0_3x_jpg_f080eaf8-27cb-4464-935f-f3497181e399.webp?v=1785150418",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1800.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2605.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "48020000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212489666678",
          "title": "The Victoria Set With A Elongated Cushion Moissanite",
          "handle": "the-victoria-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1850.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-ECU-WG_0_3x_jpg_3214bdbc-87e5-485c-a7c9-fa6c9de6cc45.webp?v=1785156168",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910212386934",
            "availableForSale": true,
            "price": {
              "amount": "1850.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-ECU-YG_0_3x_jpg_34ff9af5-0045-4a8d-83cb-2f65dff4a356.webp?v=1785156168",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1850.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2677.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "49354000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212461125750",
          "title": "The Luna Set With A Elongated Cushion Moissanite",
          "handle": "the-luna-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1850.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/407Q-ECU-WG_0_3x_jpg_efeacc74-5da2-4cfa-9d02-80ebec89fa55.webp?v=1785155113",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910160318582",
            "availableForSale": true,
            "price": {
              "amount": "1850.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/407Q-ECU-YG_0_3x_jpg_b4ed7dda-5ecf-4432-a939-b1e764dafe14.webp?v=1785155114",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1850.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2677.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "49354000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212401750134",
          "title": "The Pave Lexie Set With A Elongated Cushion Moissanite",
          "handle": "the-lexie-set-with-a-e-cushion-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1850.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-ECU-WG_0_3x_jpg_ff3c41f7-7b9a-4b2f-896c-2056f563d28c.webp?v=1785152870",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910022201462",
            "availableForSale": true,
            "price": {
              "amount": "1850.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-ECU-YG_0_3x_jpg_0426ee0e-43bf-44dd-a4b9-44956f48e3fa.webp?v=1785152870",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1850.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2677.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "49354000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212417020022",
          "title": "The Lily Set With A Elongated Cushion Moissanite",
          "handle": "the-lily-set-with-a-e-cushion-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1850.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/406Q-ECU-WG_0_3x_jpg_519cb48e-f0f5-4aef-96d6-c0716d845148.webp?v=1785153429",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910049595510",
            "availableForSale": true,
            "price": {
              "amount": "1850.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/406Q-ECU-YG_0_3x_jpg_5996406a-5170-4f9d-b721-c101a8fa5118.webp?v=1785153429",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1850.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "2677.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "49354000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Emerald": {
      "generatedAt": 1785812887535,
      "total": 135,
      "products": [
        {
          "id": "gid://shopify/Product/8212338638966",
          "title": "The Pave Ashley Set With A Emerald Moissanite",
          "handle": "the-ashley-set-with-a-emerald-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "780.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-EM-WG_0_3x_jpg_728b0542-5fae-47be-941c-26e5d1362d1d.webp?v=1785150499",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909903876214",
            "availableForSale": true,
            "price": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-EM-YG_0_3x_jpg_df926591-3d8d-48bc-a4db-0886136d3e48.webp?v=1785150499",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1129.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "20809000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212154843254",
          "title": "The Lexie Set With A Emerald Moissanite",
          "handle": "the-lexie-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-EM-WG_0_8985ce62-248f-4963-8803-459ada8f74b3.webp?v=1785139371",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909216731254",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-EM-YG_0_2ee6e56f-fcc8-464c-a98d-c3f55bffb02d.webp?v=1785139371",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212402929782",
          "title": "The Pave Lexie Set With A Emerald Moissanite",
          "handle": "the-lexie-set-with-a-emerald-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-EM-WG_0_3x_jpg_23f569db-69b9-4d52-8bc0-30482c283d5d.webp?v=1785152926",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910024626294",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-EM-YG_0_3x_jpg_8a930138-1197-4f32-9e39-b81124af6ae3.webp?v=1785152926",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212177944694",
          "title": "The Alison Set With A Emerald Moissanite",
          "handle": "the-alison-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-EM-WG_0_3x_jpg_2da21b22-ae3f-41b1-a873-74024317737c.webp?v=1785140994",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909368512630",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-EM-YG_0_3x_jpg_99252216-4f2b-4124-8059-b6ad8385e856.webp?v=1785140994",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212714815606",
          "title": "The Pave Alison Set With A Emerald Moissanite",
          "handle": "the-alison-set-with-a-emerald-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-EM-WG_0_3x_jpg_be37bb40-80d7-4b86-81d3-380ac51775f1.webp?v=1785160392",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910639353974",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-EM-YG_0_3x_jpg_619c43bb-73da-4f42-927b-24115a3617a6.webp?v=1785160392",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212182335606",
          "title": "The Katelyn Set With A Emerald Moissanite",
          "handle": "the-katelyn-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "878.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-EM-WG_0_a598111c-858e-458c-8a4a-042e31cc6272.jpg?v=1785141625",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909401739382",
            "availableForSale": true,
            "price": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-EM-YG_0_a86c679f-7fe9-4825-b474-717d89d65223.jpg?v=1785141625",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1271.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "23423000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212195344502",
          "title": "The Twig Set With A Emerald Moissanite",
          "handle": "the-twig-set-with-a-emerald-polished-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-EM-WG_0_3x_jpg_d7158697-86b6-45f1-99de-180d889b3bec.webp?v=1785143635",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909495521398",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-EM-YG_0_3x_jpg_0af9d723-81af-459a-8465-5db7d348a3a4.webp?v=1785143635",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213189558390",
          "title": "The Pave Twig Set With A Emerald Moissanite",
          "handle": "the-twig-set-with-a-emerald-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-EM-WG_0_3x_jpg_69d3d384-367c-4cf4-b0dc-7e59696270f5.webp?v=1785174767",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911677018230",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-EM-YG_0_3x_jpg_829981d8-8dac-492b-a556-5463cf5bbb8e.webp?v=1785174767",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212186497142",
          "title": "The Kamellie Set With A Emerald Moissanite",
          "handle": "the-kamellie-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-EM-WG_0_3x_jpg_71a2b912-395a-4ed5-a164-df9a674b0199.webp?v=1785142512",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909438799990",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-EM-YG_0_3x_jpg_aaec33bd-7619-4c36-a39c-7a0717554810.webp?v=1785142512",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212924727414",
          "title": "The Pave Kamellie Set With A Emerald Moissanite",
          "handle": "the-kamellie-set-with-a-emerald-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-EM-WG_0_3x_jpg_f3e55194-107b-4ead-a2b3-f52be91c37c9.webp?v=1785166461",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911072514166",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-EM-YG_0_3x_jpg_afe3211a-c7c8-4baf-be25-ed703af9cee2.webp?v=1785166461",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212305182838",
          "title": "The Textured Twig Set With A Emerald Moissanite",
          "handle": "the-twig-set-with-a-emerald-textured-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-EM-WG_0_3x_jpg_f9cff5ef-aa22-40a1-adb9-703b0b9c5305.webp?v=1785149298",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909837357174",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-EM-YG_0_3x_jpg_a421d96b-d3d0-45df-8639-6d434117988f.webp?v=1785149298",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212842578038",
          "title": "The Halo Twig Set With A Emerald Moissanite",
          "handle": "the-twig-set-with-a-emerald-halo-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-EM-WG_0_3x_jpg_4d3f6e48-1f24-4e35-a3b3-03e3293d5de1.webp?v=1785164167",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910884130934",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-EM-YG_0_3x_jpg_e8d514fb-db7b-458e-a215-cf3bf8fad1a4.webp?v=1785164167",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213204664438",
          "title": "The Three Stone Twig Set With A Emerald Moissanite",
          "handle": "the-twig-set-with-a-emerald-three-stone-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-EM-WG_0_07a66e61-90e7-4cd1-b7da-f0a4b4f4e6a4.jpg?v=1785175287",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911706935414",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-EM-YG_0_f8228d2f-9543-4fc3-bae3-a4951f48771f.jpg?v=1785175287",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212285653110",
          "title": "The Berta Set With A Emerald Moissanite",
          "handle": "the-berta-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-EM-WG_0_b646e1d0-6801-45a4-96b0-4255666cb57b.jpg?v=1785148561",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909802557558",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-EM-YG_0_99867209-8225-486d-8bb5-664524015edc.jpg?v=1785148561",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212231258230",
          "title": "The Nelly Set With A Emerald Moissanite",
          "handle": "the-nelly-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-EM-WG_0_3x_jpg_91c1513f-746f-4936-8496-d857e77ab29a.webp?v=1785146315",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909653954678",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-EM-YG_0_3x_jpg_9092e441-b2c2-491c-be24-9a23de55dcee.webp?v=1785146315",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212251770998",
          "title": "The Alex Set With A Emerald Moissanite",
          "handle": "the-alex-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-EM-WG_0_3x_jpg_8946d6d7-d936-4f50-abad-a12f0cd1f7bf.webp?v=1785147068",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909729157238",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-EM-YG_0_3x_jpg_209566cf-69e8-45d4-a63f-123d9a3395d2.webp?v=1785147068",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212200095862",
          "title": "The Razor Kamellie Set With A Emerald Moissanite",
          "handle": "the-razor-kamellie-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-EM-WG_0_3x_jpg_46eb8c13-22e5-4584-b7fd-352731ab012b.webp?v=1785144975",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909552930934",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-EM-YG_0_3x_jpg_9b6bb82d-fa26-4574-b31c-d80c074e9400.webp?v=1785144979",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213094793334",
          "title": "The Pave Alex Set With A Emerald Moissanite",
          "handle": "the-alex-set-with-a-emerald-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-EM-WG_0_3x_jpg_f3065c68-d88a-4c6b-ad0e-c4667904fb2d.webp?v=1785171625",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911496138870",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-EM-YG_0_3x_jpg_27ad9ab3-783c-4352-ae3b-09bbfee77783.webp?v=1785171625",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212202225782",
          "title": "The Low Profile Kamellie Set With A Emerald Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-EM-WG_0_3x_jpg_d2e1412a-e908-4f0b-a14b-499c55679e61.webp?v=1785145689",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909574131830",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-EM-YG_0_3x_jpg_e65d13b0-7a9b-46ae-ad7f-4dc680534c3e.webp?v=1785145688",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213109309558",
          "title": "The Pave Nelly Set With A Emerald Moissanite",
          "handle": "the-nelly-set-with-a-emerald-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-EM-WG_0_3x_jpg_b5ef1b33-1356-4869-b856-7ace518e8684.webp?v=1785172122",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911527989366",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-EM-YG_0_3x_jpg_cc229374-8035-4331-9a2d-f62d3e11ce2e.webp?v=1785172122",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213127200886",
          "title": "The Low Profile Kamellie Set With A Emerald Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-emerald-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-EM-WG_0_3x_jpg_bd195809-9aab-49bf-9e19-039bbb2ee029.webp?v=1785172735",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911559577718",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-EM-YG_0_3x_jpg_457f91d6-b66f-410f-87bd-3e5bae640e50.webp?v=1785172735",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212491403382",
          "title": "The Victoria Set With A Emerald Moissanite",
          "handle": "the-victoria-set-with-a-emerald-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-EM-WG_0_3x_jpg_d24155b9-14a1-4cca-b8fb-ac90793ac911.webp?v=1785156220",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910214975606",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-EM-YG_0_3x_jpg_b49310bf-87af-4bb6-87bf-c765e46789e8.webp?v=1785156220",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Marquise": {
      "generatedAt": 1785812887535,
      "total": 126,
      "products": [
        {
          "id": "gid://shopify/Product/8212343292022",
          "title": "The Pave Ashley Set With A Marquise Moissanite",
          "handle": "the-ashley-set-with-a-marquise-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "780.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-MQ-WG_0_3x_jpg_bc7f8376-464b-4bb2-8d7a-925525c613b5.webp?v=1785150726",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909911183478",
            "availableForSale": true,
            "price": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-MQ-YG_0_3x_jpg_76f5edcb-2b9e-4da8-a8c3-4c59fd0bdafc.webp?v=1785150726",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1129.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "20809000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212155498614",
          "title": "The Lexie Set With A Marquise Moissanite",
          "handle": "the-lexie-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-MQ-WG_0_c0d54237-990b-47f4-bc8d-b9d8cd2d8380.webp?v=1785139710",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909229740150",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-MQ-YG_0_95f583f2-c55f-462f-9bd3-d89ec31ce55a.webp?v=1785139710",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212407648374",
          "title": "The Pave Lexie Set With A Marquise Moissanite",
          "handle": "the-lexie-set-with-a-marquise-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-MQ-WG_0_3x_jpg_39d9b50a-28d5-47ee-8ca4-b3b216144664.webp?v=1785153072",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910032064630",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-MQ-YG_0_3x_jpg_30a1411d-d384-463b-8e6b-dad41aaf1473.webp?v=1785153072",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212179550326",
          "title": "The Alison Set With A Marquise Moissanite",
          "handle": "the-alison-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-MQ-WG_0_3x_jpg_a38b8786-ef9b-4674-a390-cdec27cafabd.webp?v=1785141211",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909378834550",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-MQ-YG_0_3x_jpg_96792ab9-b43f-4e23-b8ff-174366ad0d87.webp?v=1785141211",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212724973686",
          "title": "The Pave Alison Set With A Marquise Moissanite",
          "handle": "the-alison-set-with-a-marquise-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-MQ-WG_0_3x_jpg_1cb5c424-4c42-4177-a3d4-2b9a76813d0d.webp?v=1785160565",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910655180918",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-MQ-YG_0_3x_jpg_a8c36e45-f0bf-4577-95eb-dd5a59c1c0e9.webp?v=1785160565",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212183056502",
          "title": "The Katelyn Set With A Marquise Moissanite",
          "handle": "the-katelyn-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "878.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-MQ-WG_0_14a8e510-3b11-42f6-93e5-4accc1baca32.jpg?v=1785141801",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909407113334",
            "availableForSale": true,
            "price": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-MQ-YG_0_81e8f43b-6720-435b-8520-cca1f82a25ab.jpg?v=1785141801",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1271.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "23423000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212187119734",
          "title": "The Kamellie Set With A Marquise Moissanite",
          "handle": "the-kamellie-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-WG_0_3x_jpg_331f9cf8-a1ed-44a7-90d5-803854f09ead.webp?v=1785142904",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909444960374",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-YG_0_3x_jpg_e57a9362-bbd9-4711-9c2c-494c09a56595.webp?v=1785142904",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212196065398",
          "title": "The Twig Set With A Marquise Moissanite",
          "handle": "the-twig-set-with-a-marquise-polished-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-WG_0_3x_jpg_f5957b2a-761b-4fe3-8782-4e35547f8e3e.webp?v=1785143861",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909504729206",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-YG_0_3x_jpg_05fb307b-203d-4f3f-a05b-985deae83dad.webp?v=1785143861",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212310163574",
          "title": "The Textured Twig Set With A Marquise Moissanite",
          "handle": "the-twig-set-with-a-marquise-textured-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-WG_0_3x_jpg_82d91aae-d99c-4fc8-9729-b06af81722cd.webp?v=1785149493",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909845713014",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-YG_0_3x_jpg_d610459e-6083-4470-922a-c36a3173b2c4.webp?v=1785149494",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212944846966",
          "title": "The Pave Kamellie Set With A Marquise Moissanite",
          "handle": "the-kamellie-set-with-a-marquise-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-WG_0_3x_jpg_5c4a1fee-774a-49b0-b2b7-84a8592ae0db.webp?v=1785166841",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911160660086",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-YG_0_3x_jpg_56ef44da-973d-4b0b-89cc-44946fcfff18.webp?v=1785166841",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212847788150",
          "title": "The Halo Twig Set With A Marquise Moissanite",
          "handle": "the-twig-set-with-a-marquise-halo-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-MQ-WG_0_3x_jpg_f120a0d4-436a-4d57-b8f9-5a9ddbea8cb5.webp?v=1785164328",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910892585078",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-MQ-YG_0_3x_jpg_b031e9f6-5f37-486b-8d5a-662a0d79bb53.webp?v=1785164328",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213192114294",
          "title": "The Pave Twig Set With A Marquise Moissanite",
          "handle": "the-twig-set-with-a-marquise-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-MQ-WG_0_3x_jpg_94962a8c-9ffd-480f-969c-57bb685dd0de.webp?v=1785174878",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911684882550",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-MQ-YG_0_3x_jpg_a73ab987-d42d-4cc2-8108-d5937dc32317.webp?v=1785174877",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213209022582",
          "title": "The Three Stone Twig Set With A Marquise Moissanite",
          "handle": "the-twig-set-with-a-marquise-three-stone-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-MQ-WG_0_b15d8691-61b9-43e6-ba0e-2f4eadf824b1.jpg?v=1785175433",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911717978230",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-MQ-YG_0_febf332c-72db-4410-b6be-0c6f6d63a315.jpg?v=1785175433",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212290470006",
          "title": "The Berta Set With A Marquise Moissanite",
          "handle": "the-berta-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-MQ-WG_0_7233d192-69a7-4eb8-87bc-8712f08f03d7.jpg?v=1785148716",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909814616182",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-MQ-YG_0_2dccb014-1c9e-4fa7-a0e4-7bb51d2dfcd9.jpg?v=1785148716",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212200685686",
          "title": "The Razor Kamellie Set With A Marquise Moissanite",
          "handle": "the-razor-kamellie-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-MQ-WG_0_3x_jpg_f066da8c-74e3-43e7-b96b-b7357f34ce10.webp?v=1785145157",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909562007670",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-MQ-YG_0_3x_jpg_9c6d5a49-69a1-419e-9c6d-777f7cb55ce0.webp?v=1785145157",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213130772598",
          "title": "The Low Profile Kamellie Set With A Marquise Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-marquise-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-MQ-WG_0_3x_jpg_8e19a9fe-9801-4f8c-b3e9-29ce938ecad1.webp?v=1785172861",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911564951670",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-MQ-YG_0_3x_jpg_e4440380-a0a4-4b94-8d0a-a2ef5ac7ff8e.webp?v=1785172861",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212210942070",
          "title": "The Low Profile Kamellie Set With A Marquise Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-MQ-WG_0_3x_jpg_0a326429-b338-49e5-b81f-c2c550796150.webp?v=1785145898",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909590024310",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-MQ-YG_0_3x_jpg_0da4f6df-fd37-4727-b0dc-d350a7e6685f.webp?v=1785145899",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212325892214",
          "title": "The Margot Set With A Marquise Moissanite",
          "handle": "the-margot-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-MQ-WG_0_c38dc434-3bfc-4a46-916f-b22981b7da80.jpg?v=1785150026",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909876482166",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-MQ-YG_0_6daa323f-29ec-4b5c-9114-b88db3d62099.jpg?v=1785150022",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213176483958",
          "title": "The Pave Margot Set With A Marquise Moissanite",
          "handle": "the-margot-set-with-a-marquise-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412QS-ER-MQ-WG_0_0fc91a03-fc9f-451c-b692-bc9d1bbc6f74.jpg?v=1785174372",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911652606070",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412QS-ER-MQ-YG_0_c322a173-4b94-4612-893b-c554e94dc2b3.jpg?v=1785174372",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213541978230",
          "title": "The Pave Victoria Set With A Marquise Moissanite",
          "handle": "the-victoria-set-with-a-marquise-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404QS-ER-MQ-WG_CAD_d1f2462e-ecf1-4c2f-9fe4-ce4b5304d268.jpg?v=1785187023",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43912481308790",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404QS-ER-MQ-YG_CAD_04e9dfff-e3fc-4f07-87f8-88c0f1bb6f66.jpg?v=1785187023",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212497825910",
          "title": "The Victoria Set With A Marquise Moissanite",
          "handle": "the-victoria-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-MQ-WG_0_3x_jpg_d17ae280-4fb6-4603-83cb-d7a42ef9bcac.webp?v=1785156460",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910224314486",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/404Q-MQ-YG_0_3x_jpg_3df66fe3-95f4-486c-a68a-4e947727b194.webp?v=1785156460",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212810858614",
          "title": "The Scarlett Set With A Marquise Moissanite",
          "handle": "the-scarlett-set-with-a-marquise-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1073.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/221Q-ER-MQ-WG_0_3x_jpg_26d3ee3f-3b79-4394-bc90-698e4b24fa74.webp?v=1785163276",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910817316982",
            "availableForSale": true,
            "price": {
              "amount": "1073.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/221Q-ER-MQ-YG_0_3x_jpg_423f3c6b-a074-4e09-b956-972c77acd00d.webp?v=1785163276",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1073.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1553.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "28625000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    },
    "Radiant": {
      "generatedAt": 1785812887535,
      "total": 135,
      "products": [
        {
          "id": "gid://shopify/Product/8212340179062",
          "title": "The Pave Ashley Set With A Radiant Moissanite",
          "handle": "the-ashley-set-with-a-radiant-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "780.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-RAD-WG_0_3x_jpg_0df87447-beec-4be5-a1b0-c74c8569eb5a.webp?v=1785150575",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909906301046",
            "availableForSale": true,
            "price": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/391QS-RAD-YG_0_3x_jpg_c37dac17-b1b3-4970-b78f-bcdf4dfde5fb.webp?v=1785150575",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "780.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1129.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "20809000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212155007094",
          "title": "The Lexie Set With A Radiant Moissanite",
          "handle": "the-lexie-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-RAD-WG_0_067f6ddb-df66-4ffb-96b0-cb6117ed112b.webp?v=1785139552",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909218664566",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383Q-RAD-YG_0_28c8e300-5f4d-4ff4-9925-2a65ad7d0620.webp?v=1785139552",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212404469878",
          "title": "The Pave Lexie Set With A Radiant Moissanite",
          "handle": "the-lexie-set-with-a-radiant-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "813.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-RAD-WG_0_3x_jpg_b02dc851-a54c-4527-953d-81054ee656e8.webp?v=1785152973",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910026952822",
            "availableForSale": true,
            "price": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/383QS-RAD-YG_0_3x_jpg_0e1048cd-a423-4ca1-aff9-ea02c4a78f51.webp?v=1785152973",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "813.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1177.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "21689000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212179288182",
          "title": "The Alison Set With A Radiant Moissanite",
          "handle": "the-alison-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-RAD-WG_0_3x_jpg_4d27fde3-ed5d-49fe-8d8a-2351fb2af0ad.webp?v=1785141051",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909374181494",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393Q-RAD-YG_0_3x_jpg_5d215622-183f-4015-b5b4-9ef7b5e34658.webp?v=1785141050",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212717895798",
          "title": "The Pave Alison Set With A Radiant Moissanite",
          "handle": "the-alison-set-with-a-radiant-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "845.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-RAD-WG_0_3x_jpg_cb9fec54-817e-4e73-983d-b48da4fc4183.webp?v=1785160444",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910644695158",
            "availableForSale": true,
            "price": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/393QS-ER-RAD-YG_0_3x_jpg_63eead50-1e57-4371-9c3e-99dfdf4b30a7.webp?v=1785160444",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "845.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1223.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "22543000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212182466678",
          "title": "The Katelyn Set With A Radiant Moissanite",
          "handle": "the-katelyn-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "878.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-RAD-WG_0_83c14ae8-38a5-43c6-96bc-cb0db8e60c46.jpg?v=1785141698",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909403508854",
            "availableForSale": true,
            "price": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/413Q-ER-RAD-YG_0_d97296a4-e451-4492-8ae1-af52f03c811c.jpg?v=1785141698",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "878.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1271.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "23423000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212186660982",
          "title": "The Kamellie Set With A Radiant Moissanite",
          "handle": "the-kamellie-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-RAD-WG_0_3x_jpg_056da138-e0a5-4c30-be71-942dc8ca1b44.webp?v=1785142626",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909442109558",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162Q-ER-RAD-YG_0_3x_jpg_f2f9dd7f-d612-47f9-9f17-55173200b508.webp?v=1785142627",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212195475574",
          "title": "The Twig Set With A Radiant Moissanite",
          "handle": "the-twig-set-with-a-radiant-polished-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-RAD-WG_0_3x_jpg_72e12594-fb72-4087-b9c5-3f182fd3f4e1.webp?v=1785143711",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909496537206",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4Q-ER-RAD-YG_0_3x_jpg_e24e4252-4cac-43ff-9d86-f2db649597b4.webp?v=1785143711",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212929249398",
          "title": "The Pave Kamellie Set With A Radiant Moissanite",
          "handle": "the-kamellie-set-with-a-radiant-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-RAD-WG_0_3x_jpg_1cd1fd68-44d5-4dff-a340-167fc42779ca.webp?v=1785166575",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911085293686",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/162QS-ER-RAD-YG_0_3x_jpg_40de5ae4-89dd-4ac0-8773-108024da391a.webp?v=1785166575",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213190836342",
          "title": "The Pave Twig Set With A Radiant Moissanite",
          "handle": "the-twig-set-with-a-radiant-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-RAD-WG_0_3x_jpg_f048aed1-ef36-4033-be2a-a623460eed0f.webp?v=1785174818",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911680753782",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/387Q-RAD-YG_0_3x_jpg_dbadd4c3-4ab2-4278-9027-ee7ea22291b6.webp?v=1785174818",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212308164726",
          "title": "The Textured Twig Set With A Radiant Moissanite",
          "handle": "the-twig-set-with-a-radiant-textured-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-RAD-WG_0_3x_jpg_59d201e1-580b-4f31-a253-9e37e82833c7.webp?v=1785149387",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909841813622",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/4QT-ER-RAD-YG_0_3x_jpg_6e72614d-4027-49c8-9022-55ea85f80304.webp?v=1785149387",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212844413046",
          "title": "The Halo Twig Set With A Radiant Moissanite",
          "handle": "the-twig-set-with-a-radiant-halo-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-RAD-WG_0_3x_jpg_9088e11f-b31a-42c3-8c90-8fb911ed730c.webp?v=1785164221",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43910887047286",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/403Q-RAD-YG_0_3x_jpg_d1171722-bd1a-4f26-9c01-82670f00509f.webp?v=1785164221",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213206433910",
          "title": "The Three Stone Twig Set With A Radiant Moissanite",
          "handle": "the-twig-set-with-a-radiant-three-stone-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "943.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-RAD-WG_0_c654b411-ac3b-4e9f-89e3-f1e2126b456c.jpg?v=1785175349",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911714439286",
            "availableForSale": true,
            "price": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/423Q-ER-RAD-YG_0_73cd0121-5f93-4c75-a86d-745556921f06.jpg?v=1785175349",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "943.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1365.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "25157000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212287291510",
          "title": "The Berta Set With A Radiant Moissanite",
          "handle": "the-berta-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-RAD-WG_0_29cdd559-17f8-4817-969f-bc3eaabde7e4.jpg?v=1785148613",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909805637750",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/421Q-ER-RAD-YG_0_376b6a4f-5a58-41a3-87e9-26edf3c455e2.jpg?v=1785148613",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212235026550",
          "title": "The Nelly Set With A Radiant Moissanite",
          "handle": "the-nelly-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-RAD-WG_0_3x_jpg_8a47697a-952f-4d54-a0e8-d3e954ec473a.webp?v=1785146404",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909664374902",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203Q-ER-RAD-YG_0_3x_jpg_7aac29ab-8bad-4aa0-9f38-fe5f8dcb39df.webp?v=1785146404",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212251869302",
          "title": "The Alex Set With A Radiant Moissanite",
          "handle": "the-alex-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-RAD-WG_0_3x_jpg_526481c5-2374-4af3-a09b-06506f0b86a6.webp?v=1785147130",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909730074742",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/307Q-ER-RAD-YG_0_3x_jpg_02e9591b-ea8d-456b-8dae-a27c44f39d7a.webp?v=1785147130",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213096923254",
          "title": "The Pave Alex Set With A Radiant Moissanite",
          "handle": "the-alex-set-with-a-radiant-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-RAD-WG_0_3x_jpg_2fbda013-c5fc-4653-934d-37ba996bb999.webp?v=1785171690",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911504199798",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/26Q-ER-RAD-YG_0_3x_jpg_8d490505-bb6e-4690-9f90-eded1c1d6536.webp?v=1785171689",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212200259702",
          "title": "The Razor Kamellie Set With A Radiant Moissanite",
          "handle": "the-razor-kamellie-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-RAD-WG_0_3x_jpg_b1368ef6-2716-41fd-9829-f470db272b55.webp?v=1785145023",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909555060854",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/294Q-ER-RAD-YG_0_3x_jpg_83346450-5a6d-49ef-9eea-97443be3355d.webp?v=1785145024",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213110227062",
          "title": "The Pave Nelly Set With A Radiant Moissanite",
          "handle": "the-nelly-set-with-a-radiant-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-RAD-WG_0_3x_jpg_27defb29-05e7-48f3-b718-64964d8cbffd.webp?v=1785172173",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911529726070",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/203QS-ER-RAD-YG_0_3x_jpg_4aa1ebfa-d5d2-4e14-9506-c34e082e9e71.webp?v=1785172173",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212203077750",
          "title": "The Low Profile Kamellie Set With A Radiant Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-RAD-WG_0_3x_jpg_c850d3c7-b70b-49c2-a4db-0ba24c0b016c.webp?v=1785145745",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909576491126",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/334Q-ER-RAD-YG_0_3x_jpg_e8133c5e-fa07-4d75-b440-ebf3793306fa.webp?v=1785145745",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8213128118390",
          "title": "The Low Profile Kamellie Set With A Radiant Moissanite",
          "handle": "the-low-profile-kamellie-set-with-a-radiant-pave-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1008.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-RAD-WG_0_3x_jpg_eb9161fe-ead8-467a-857d-3882144dc8f4.webp?v=1785172785",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43911561445494",
            "availableForSale": true,
            "price": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/301Q-ER-RAD-YG_0_3x_jpg_93c36078-c0e6-4a6c-af7c-46e5f5ac4cc3.webp?v=1785172785",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1008.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1459.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "26891000.0",
              "currencyCode": "VND"
            }
          }
        },
        {
          "id": "gid://shopify/Product/8212322386038",
          "title": "The Margot Set With A Radiant Moissanite",
          "handle": "the-margot-set-with-a-radiant-moissanite",
          "priceRange": {
            "minVariantPrice": {
              "amount": "1040.0",
              "currencyCode": "USD"
            }
          },
          "featuredImage": {
            "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-RAD-WG_0_bfbf6388-f6ea-45c9-b1ef-3a58f2d5c3ed.jpg?v=1785149898",
            "altText": null
          },
          "selectedVariant": {
            "id": "gid://shopify/ProductVariant/43909869437046",
            "availableForSale": true,
            "price": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "image": {
              "url": "https://cdn.shopify.com/s/files/1/0686/7451/9158/files/412Q-ER-RAD-YG_0_eb6368e8-93df-45f2-9f63-1d6a06a1e6a3.jpg?v=1785149898",
              "altText": null
            },
            "selectedOptions": [
              {
                "name": "Material",
                "value": "14k Yellow Gold"
              },
              {
                "name": "Carat",
                "value": "1"
              }
            ]
          },
          "marketPrices": {
            "US": {
              "amount": "1040.0",
              "currencyCode": "USD"
            },
            "AU": {
              "amount": "1505.0",
              "currencyCode": "AUD"
            },
            "VN": {
              "amount": "27745000.0",
              "currencyCode": "VND"
            }
          }
        }
      ]
    }
  }
};
